{
  "neighborhoods": true,
  "country_code": "595",
  "currency_config_up": "PY",
  "showLocale": true,
  "masks": {
    "mi": "KM",
    "phone": "(000) 000-000",
    "cell": "(000) 000 000-0000",
    "secret_number": "########",
    "secret_number_company": "########",
    "ssn_mask": "CPF_CNPJ",
    "secret_number_mask": "CPF",
    "zipcode": "0000",
    "date_mask": "dd/MM/yyyy",
    "date_mask_format_m": "DD/MM/YYYY",
    "date_mask_two": "dd/MM",
    "states": [
      "Alto Paraguay",
      "Alto Paraná",
      "Amambay",
      "Asunción (Distrito Capital)",
      "Boquerón",
      "Caaguazú",
      "Caazapá",
      "Canindeyú",
      "Central",
      "Concepción",
      "Cordillera",
      "Guairá",
      "Itapúa",
      "Misiones",
      "Ñeembucú",
      "Paraguarí",
      "Presidente Hayes",
      "San Pedro"
    ]
  },
  "sort_by": "Ordenar por",
  "sale_without_registration": "Venta sin registro",
  "i_dont_need_indentify_client": "No necesito identificar al cliente",
  "uf": "UF",
  "order_code": "Código del pedido",
  "favorite_card_comment": "Ej: Mi tarjeta favorita",
  "finalize_order_comment": "Finalizar pedido",
  "goodbye": "¡Hasta luego!",
  "possibles": "possibiles",
  "opened": "abierto",
  "closed": "cerrado",
  "optional": "opcional",
  "are_you_here": "¿estás aquí?",
  "add_comment": "+Agregar",
  "confirm_send_to_whatsapp": "¿Confirmas enviar el pedido por WhatsApp?",
  "send_message": "Enviar mensaje",
  "dont_send_message": "No enviar mensaje",
  "obs": "Observaciones",
  "your_location": "tu ubicación. arrastra el marcador para ajustar.",
  "my_orders": "mis pedidos",
  "tax_and_time_of_shipping": "tarifa y tiempo de entrega",
  "scheduling": "Pedidos programados",
  "scheduling2": "Programación",
  "package": "Pedido",
  "close_order": "cerrar pedido",
  "adjust_location": "Ajustar ubicación",
  "verify": "verificar",
  "add_more_items": "agregar más artículos",
  "next": "Siguiente",
  "cart_empty": "Carrito vacío",
  "edit_item": "editar artículo",
  "select_shipoing": "Elige el método de entrega",
  "take_out": "recoger en el lugar",
  "pick_up_counter": "Recoger en el mostrador",
  "cupom": "cupón",
  "active_your_cupom": "activar tu cupón",
  "code_of_cupom": "código del cupón",
  "total": "total",
  "select_the_form_of_shipping": "Elige la forma de entrega",
  "mandatory": "obligatorio",
  "go_to_payment": "ir al pago",
  "pay_on_app": "pagar en la app",
  "pay_on_shippingg": "pagar al recibir",
  "discont": "Descuento",
  "discount_comment": "Descuento",
  "payment_in_comment": "Pago en",
  "cash_payment": "pago en efectivo",
  "payment_debit_card": "pago con tarjeta de débito",
  "payment_credit_card": "pago con tarjeta de crédito",
  "i_need_transhipment": "necesito cambio para",
  "i_not_need_transhipment": "No necesito cambio",
  "secret_number_on_note": "RFC en el recibo",
  "search_products_by_name_or_description": "Buscar productos por nombre o descripción",
  "outside_the_coverage_area": "fuera del área de cobertura",
  "unavilable": "No disponible",
  "avaible": "disponible",
  "product_unavilable": "producto no disponible",
  "unavilable_amount": "cantidad no disponible",
  "table_s": "mesas",
  "discont_of": "descuento de",
  "free_freight": "envío gratis",
  "free_freight_comment": "Envío Gratis",
  "covered_address": "Dirección fuera de cobertura",
  "send_order": "enviar pedido",
  "you_are_blocked": "estás bloqueado",
  "enter_your_cell": "ingresa tu número de celular/WhatsApp",
  "enter_your_email": "ingresa tu correo electrónico",
  "enter_your_address": "ingresa tu dirección",
  "enter_you_ddd": "Ingresa el celular/WhatsApp con LADA",
  "minimum_unconceived_value": "valor mínimo no alcanzado",
  "finish_payment_pix": "finalizar pago vía PIX",
  "finish_payment": "finalizar pago",
  "my_cards": "mis tarjetas",
  "payment_online": "pago en línea",
  "payment_offline": "pago al recibir",
  "add_new_card": "agregar nueva tarjeta",
  "pay_on_delivery": "pagar al recibir",
  "i_need_change_for": "necesito cambio para",
  "i_dont_need_change": "no necesito cambio",
  "send_the_receipt": "envía el comprobante a nuestro WhatsApp para agilizar tu atención",
  "copy_key": "copiar clave",
  "select_the_flag": "Selecciona la marca",
  "select_the_flag_comment": "Selecciona una marca",
  "cpf_on_the_receipt": "RFC en el recibo",
  "cpf_cnpj_invalid": "RFC Inválido",
  "how_to_pay_with_pix": "Cómo pagar con PIX",
  "enter_cpf_generate_pix": "Ingresa tu RFC para generar una clave PIX",
  "enter_cpf": "Ingresa tu RFC",
  "enter_a_valid_cpf": "Ingresa un RFC válido",
  "order_pending_payment": "pedido en espera de pago",
  "generate_pix_key": "Generar clave PIX",
  "pix_copy_paste": "PIX Copiar y pegar",
  "copy_code": "copiar código",
  "pix_key_expired": "Tu clave PIX ha expirado. Haz clic en el botón para generar una nueva",
  "paste_this_code_your_bank": "Pega este código en la opción PIX Copiar y Pegar de tu banco",
  "verify_pix_payment": "Verificar pago por PIX",
  "card_details": "datos de la tarjeta",
  "name_on_the_card": "nombre en la tarjeta",
  "card_number": "número de la tarjeta",
  "expiry": "vigencia",
  "card_nickname": "apodo de la tarjeta (opcional)",
  "billing_adress": "dirección de facturación",
  "zip_code_not_found": "Código postal no encontrado",
  "adress_line_2": "complemento (opcional)",
  "order_will_be_delivered": "el pedido será entregado en",
  "to_consult": "A consultar",
  "flavors_comment": "Sabores",
  "flavor_comment": "Sabor",
  "crust": "Orilla",
  "add_ons": "Complementos",
  "add_on": "Complemento",
  "general_toppings": "complementos generales",
  "single_crust": "orilla única",
  "message_cvv_payment": "Ingresa el código CVV de tu tarjeta para finalizar el pago",
  "code_back_of_your_card": "este código está al reverso de tu tarjeta",
  "complete_payment": "finalizar pago",
  "what_card_nickname": "¿Cuál es el apodo de esta tarjeta?",
  "use_cashback": "usar saldo de cashback",
  "balance": "saldo",
  "indentify_yourself": "identifícate",
  "whatsapp_number": "número de WhatsApp",
  "number_comment": "Número",
  "date_of_birth": "fecha de nacimiento",
  "place_order_necessary_information": "para realizar el pedido anterior, es necesario completar los datos solicitados",
  "order_slip_s": "Comandas",
  "zip_invalid": "Código postal inválido",
  "no_active_orders": "no hay pedidos activos",
  "order_sucess": "pedido realizado con éxito",
  "send_confirmation_whatsapp": "enviar confirmación por WhatsApp",
  "select_delivery_date": "selecciona una fecha para la entrega",
  "time_zone_is_different": "Identificamos que tu zona horaria es diferente a la del establecimiento. Al lado del horario aparecerá tu hora de recepción correspondiente",
  "delivery_time_between": "elige un horario de entrega entre los períodos",
  "delivery_for_order": "elige un horario de entrega para tu pedido",
  "establishment_notes": "observaciones del establecimiento",
  "no_more_avaible_slots_for_orders": "no hay más espacios disponibles para pedidos, por favor contacta al establecimiento",
  "contact_establishment": "contactar al establecimiento",
  "no_slots_avaible_for_orders_on_that_day": "no hay espacios disponibles para pedidos ese día",
  "please_select_another_date": "por favor selecciona otra fecha",
  "continue": "continuar",
  "last_orders": "Últimos pedidos",
  "view_order": "ver pedido",
  "edit_addresses": "editar direcciones",
  "addresses": "dirección",
  "add_new_addresses": "agregar nueva dirección",
  "create_address_or_use_list_below": "crea una nueva dirección o usa la lista a continuación",
  "more_information": "más información",
  "notification_permissions": "para recibir notificaciones, es necesario aceptar el permiso en tu dispositivo",
  "opening_hours": "horario de atención",
  "from_de": "De",
  "to": "hasta",
  "pay_online": "pagar en línea",
  "choose_this_option_secure_payment": "elige esta opción para realizar el pago de forma segura a través de nuestro sistema",
  "choose_option_receiving": "¿Prefieres pagar al recibir tu pedido? Elige esta opción",
  "acess_your_payment_app": "accede a tu app de pagos",
  "qrcode_copy_paste_payment": "escanea el código QR o copia y pega el código de pago",
  "pay_credited_instantly": "paga y se acreditará al instante",
  "enter your cpf": "Ingresa tu RFC",
  "n": "Nº",
  "payment_still_pending": "el pago sigue pendiente. Por favor, intenta de nuevo",
  "confirmation_is_taking_too_long": "si la confirmación está tardando demasiado, haz clic en el botón para continuar",
  "use_delivery_address": "usar dirección de entrega",
  "state": "estado",
  "payment_meal_voucher": "pago con vale de comida",
  "payment_food_voucher": "pago con vale de despensa",
  "receipt_to_our_whatsapp": "envía el comprobante a nuestro WhatsApp para agilizar tu atención",
  "total_to_transfer": "total a transferir",
  "type_of_key": "tipo de clave",
  "save_future_purchases": "guardar para futuras compras",
  "finalize_order": "finalizar pedido",
  "choose_single_crust": "elige la orilla única",
  "choose_single_crust_comment": "Elige la Orilla Única",
  "choose_crust_comment": "Elige la Orilla",
  "crust_without_filling": "sin orilla",
  "choose_the": "Elige la",
  "choose_the_o": "Elige el",
  "complete_order_mandotory": "completa tu pedido con los elementos obligatorios",
  "no_orders_moment": "sin pedidos en este momento",
  "fee_comment": "Tarifa",
  "pickup_only": "solo recogida en el local",
  "local_pickup": "Recoger en el local",
  "loading_dates": "cargando fechas",
  "choose_date": "elegir una fecha",
  "see_full_list": "haz clic aquí para ver la lista completa de productos",
  "no_products_found": "lo sentimos, no se encontraron productos",
  "size_unavilable": "tamaño no disponible",
  "edit_notes": "editar observaciones",
  "remove_item": "eliminar artículo",
  "point_camera_qrcode": "por favor apunta tu cámara al código QR de la mesa donde deseas hacer tu pedido",
  "order_status": "estado del pedido",
  "in_preparation": "en preparación",
  "canceled": "cancelado",
  "order_received": "pedido recibido",
  "pending_payment": "esperando pago",
  "order_approved": "pedido aprobado",
  "order_preparation": "pedido en preparación",
  "order_canceled": "pedido cancelado",
  "order_out_for_delivery": "pedido en camino",
  "order_ready_for_pickup": "pedido listo para recoger",
  "send_order_whatsapp": "enviar pedido por WhatsApp",
  "reference_point": "punto de referencia",
  "house_corner": "Casa de la esquina",
  "address_complement": "Complemento",
  "block_apt": "Bloque, Apto",
  "ave": "Av. Brasil",
  "date_usa": "dd/mm/aaaa",
  "choose_time": "elige un horario",
  "minimum_quantity": "Cantidad mínima",
  "maximum_quantity": "Cantidad máxima",
  "what_your_name": "¿Cuál es tu nombre?",
  "open_new_order": "Abrir nueva comanda",
  "new_order": "Nueva comanda",
  "repeat_order": "repetir pedido",
  "enter_name_your_order": "Ingresa un nombre para tu comanda",
  "select_order": "Selecciona una comanda",
  "counter_and_delivery": "Mostrador/Entrega",
  "discount_of": "descuento de",
  "applied": "aplicado",
  "addition": "Adicional",
  "change_address": "cambiar dirección",
  "message_no_costumer_selected": "Ningún cliente seleccionado para este pedido. Busca uno registrado o regístralo para continuar.",
  "search_customer": "buscar cliente",
  "add_customer": "Registrar Cliente",
  "outside_service_area": "FUERA DEL ÁREA DE COBERTURA",
  "free_comment": "Gratis",
  "free_comment_up": "GRATIS",
  "activate_coupon_comment": "Activa tu cupón",
  "order_type": "tipo de pedido",
  "place_order": "realizar pedido",
  "open_register": "abrir caja",
  "initial_balance": "Saldo Inicial $",
  "initial_balance_n": "Saldo Inicial",
  "income": "entrada",
  "cash_register_status": "estado de la caja",
  "cash_outflow": "salida",
  "cash_outflows": "salidas",
  "cod": "cód.",
  "close_cash_register": "cerrar caja",
  "cash_balance": "saldo en efectivo",
  "cashier_balance": "saldo de caja",
  "final_balance": "saldo final",
  "create_order_slip": "crear comanda",
  "change_tables": "cambiar mesas",
  "table_change": "cambio de mesa",
  "print_table": "imprimir mesa",
  "close_table": "cerrar mesa",
  "whatsapp": "WhatsApp",
  "client_comment": "Cliente",
  "no_registred_address": "ninguna dirección registrada",
  "none": "ninguno",
  "no_categories_available_at_moment": "Ninguna categoría disponible para pedidos en mesa en este momento.",
  "check_admin_panel_categories_active": "Verifica en el panel de administrador si las categorías están activas y disponibles para pedidos en mesa.",
  "search_name_comment": "Buscar por código o nombre",
  "search_flavor_comment": "Buscar por código o sabor",
  "waiting_service": "esperando atención",
  "pause_comment": "Pausar",
  "unpause_comment": "Reanudar",
  "order_buy": "pedir",
  "order_the_table": "pedir en la mesa",
  "registration_comment": "Registrando",
  "change_comment": "Cambiar",
  "one_more_comment": "Uno más",
  "customer": "clientes",
  "customer_name_comment": "Nombre del cliente",
  "customer_last_name_comment": "Apellido del cliente",
  "email_example_comment": "cliente@ejemplo.com",
  "ssn_model_comment": "000.000.000-00",
  "number_model_comment": "(00) 00000-0000",
  "order_by": "Pedido por",
  "delivery_address": "Dirección de entrega",
  "no_number": "sin número",
  "dont_know_my_zip": "No sé mi código postal",
  "other_s": "Otras",
  "deliver_this_address": "Entregar en esta dirección",
  "out_coverage_area": "fuera del área de cobertura",
  "error_generating_qrcode": "Error al generar el código QR. Por favor, intenta nuevamente.",
  "finalize_appointment": "cerrar programación",
  "payment_not_detected_check_banking": "Pago no detectado. Verifica tu aplicación bancaria.",
  "error_processing_payment": "Error al procesar el pago. Intenta nuevamente.",
  "error_creating_customer": "Error al registrar cliente. Intenta nuevamente.",
  "return_cancel": "Volver/Cancelar",
  "return": "Volver",
  "remaining": "faltan",
  "fee_discount": "Tarifa/Descuento",
  "how_pay_pix": "Cómo pagar con PIX",
  "step": "paso",
  "payment_deadline": "el tiempo para el pago termina en",
  "select_comment": "Seleccionar",
  "call_back_house": "Ej: Llamar en la casa de atrás",
  "change_for_comment": "Cambio para",
  "for": "para",
  "out for delivery": "en camino",
  "waiting_for_pickup": "esperando recogida",
  "add_flavor": "agregar sabor",
  "your_flavor": "tu sabor",
  "choose": "Elige",
  "choose_up_to": "Elige hasta",
  "selected_date_is_earlier": "la fecha seleccionada es anterior a la actual. Por favor, elige otro horario",
  "register_closing": "cierre de caja",
  "confirm_register_closing": "confirmar cierre de caja",
  "closing_insert_following": "al realizar el cierre, ingresa los siguientes valores en la caja registradora",
  "register_login": "inicio de sesión de caja",
  "deposit": "Depósito",
  "purpose": "finalidad",
  "list": "lista",
  "make_payment": "realizar pago",
  "uncancel_order": "revertir cancelación del pedido",
  "order_amount": "valor total del pedido",
  "print_the": "realizar impresión de la",
  "next_flavor_comment": "Siguiente Sabor",
  "choose_flavor_comment": "Elige el Sabor",
  "quantity_unavaible": "Cantidad no disponible",
  "complete_toppings_comment": "Completa los Complementos",
  "out_stock_toppings_comment": "Complementos sin stock",
  "in_stock_comment": "En stock",
  "the_flavors_comment": "los Sabores",
  "the_crust_comment": "las Orillas",
  "the_toppings_comment": "los Complementos",
  "mandatory_to_choose": "es obligatorio elegir",
  "time_closed_comment": "¡Horario cerrado!",
  "change_less_purchase_comment": "Cambio inferior al valor de la compra",
  "free_shipping_comment": "ENVÍO GRATIS",
  "consult_comment": "Consultar",
  "location_comment": "Ubicación",
  "paid_online_comment": "Pagado en línea",
  "track_order": "Rastrear pedido",
  "order_comment": "Pedido",
  "schedule": "Agendar",
  "closed_orders": "Pedidos Cerrados",
  "scheduling_closed": "Agendamiento Cerrado",
  "order_name": "nombre de la comanda",
  "no_product_found": "no se encontró ningún producto",
  "items_found": "artículos encontrados",
  "mandatory_items": "artículos obligatorios",
  "minimum": "mínimo",
  "advance": "Avanzar",
  "add_another_card": "agregar otra tarjeta",
  "loading_page": "Cargando...",
  "enter_city": "Ingresa la ciudad",
  "select_city": "Selecciona la ciudad",
  "enter_neighborhood": "Ingresa la colonia",
  "select_neighborhood": "Selecciona la colonia",
  "enter_street_name": "Ingresa el nombre de la calle",
  "coupon_only_used_purchases": "Este cupón solo puede usarse en compras a partir de",
  "discount_coupon_greater_total": "¡El descuento del cupón es mayor que el valor total!",
  "add_to_order": "Agregar al pedido",
  "data_print": "Fecha de impresión",
  "generate_fiscal_note": "Emitir nota fiscal",
  "alert": {
    "unable_to_read": "No se puede leer tu ubicación, verifica si no está bloqueada.",
    "address_covarage_area": "¡Tu dirección está fuera de nuestra área de cobertura!",
    "register_open_24": "Hay una caja abierta hace más de 24 horas y será cerrada.",
    "table_desactived": "¡Lo sentimos, esta mesa está desactivada!",
    "moment_table_not_avaible": "En este momento, esta mesa no está disponible para nuevos pedidos.",
    "table_not_avaible_new_orders": "En este momento, esta mesa no está disponible para nuevos pedidos.",
    "order_already_been_completed": "La comanda anterior ya fue finalizada, ¿aún estás en el restaurante o deseas hacer un nuevo pedido para entrega?",
    "at_the_table": "Estoy en la mesa",
    "deliver_order": "Entregar pedido",
    "not_belong_this_table": "Esta comanda no pertenece a esta mesa",
    "store_closed": "¡TIENDA CERRADA!",
    "not_minimum_value": "Tu pedido no alcanzó el valor mínimo de",
    "failed_validate_coupon": "Error al validar el cupón, ¡verifica tu conexión!",
    "amount_not_include_delivery_fee": "Este valor total no incluye la tarifa de entrega.",
    "coupon_used_starting_from": "Este cupón solo puede usarse en compras a partir de",
    "closed_delivery": "CERRADO PARA ENTREGA",
    "unable_create_customer": "No se pudo registrar el cliente. Por favor intenta nuevamente.",
    "selected_date_earlier_choose_later_date": "La fecha seleccionada es anterior a la actual,<br>por favor selecciona una fecha posterior.",
    "try_again_moment": "Ocurrió algo inesperado, intenta nuevamente en unos momentos.",
    "error_generate_qrcode": "No se pudo generar el código QR. Por favor, intenta nuevamente.",
    "payment_not_detected": "Pago no detectado. Verifica tu aplicación bancaria.",
    "reloaded_page_message": "¡Es necesario recargar la página!",
    "name_and_last_name_and_phone_required": "Nombre, apellido y número de teléfono son obligatorios",
    "enter_your_details": "Ingresa tus datos",
    "enter_your_name": "Ingresa tu nombre",
    "enter_your_whatsapp": "Ingresa tu WhatsApp",
    "enter_your_date_of_birth": "Ingresa tu fecha de nacimiento",
    "review_change_amount": "¡Revisa el valor del cambio!",
    "no_internet_connection": "¡Sin conexión a internet!"
  },
  "calendar": {
    "weekdays": [
      "Lun",
      "Mar",
      "Mié",
      "Jue",
      "Vie",
      "Sáb",
      "Dom"
    ],
    "months": [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ]
  },
  "timezones": [
    {
      "label": "Asunción",
      "value": "America/Asuncion"
    }
  ],
  "unitSystem": "métrico",
  "distanceinkmto": "Distancia en KM hasta",
  "distance": "Distancia",
  "the_distance_already_exists": "Esa distancia ya existe",
  "distance_added_successfully": "¡Distancia agregada con éxito!",
  "distance_deleted_successfully": "¡Distancia eliminada con éxito!",
  "update_shipping": "Actualizar envío",
  "km": "KM",
  "tobeconfirmed": "A consultar",
  "time": "Tiempo",
  "coin": "₲",
  "currency_config": "PYG",
  "ddi": "595",
  "date_format": "dd/MM/yyyy",
  "date_format_v2": "dd/MM",
  "order_updated_at": "Actualizado en",
  "welcome": "¡Bienvenido!",
  "description": "Descripción",
  "orders": "Pedidos",
  "order": "Pedido",
  "order_management": "Gestión de pedidos",
  "new_feature": "Nueva función",
  "work_waiters_taking": "¿Trabajas con meseros tomando pedidos?",
  "register_you_waiters_quickly": "Entonces registra a tus meseros y toma pedidos rápidamente.",
  "dont_work_waiters": "No trabajo con meseros",
  "register_waiters": "Registrar mis meseros",
  "orders_were_not_received": "Pedidos que no fueron recibidos.",
  "orders_appointments": "Pedidos/Agendamientos",
  "efficiency": "Agilidad",
  "incredible_agility": "Agilidad increíble en la gestión de mesas y pedidos como nunca antes; este sistema es todo lo que siempre soñaste para ganar más dinero y organizar tu restaurante.",
  "automation": "Automatización",
  "now_you_control": "Ahora controlas las mesas y comandas de tu restaurante automáticamente, sin errores ni esfuerzo adicional para tomar pedidos.",
  "qrcode_self_service": "Tecnología de autoatención con código QR por mesa, no necesitas un mesero para tomar pedidos.",
  "self_service": "Autoatención",
  "customers_place_orders_themselves": "Con esta autoatención, tus clientes hacen pedidos por sí mismos desde la mesa y se imprimen automáticamente en la cocina por orden de llegada.",
  "zero_waste": "Cero desperdicio",
  "indecipherable_handwriting": "Basta de letras ilegibles, errores y pérdidas en la preparación de platos. Mantén todo funcionando con agilidad en tu restaurante.",
  "closure": "Cierre",
  "automatically_separates_calculates": "Cierre rápido de cuenta directamente en la mesa o en caja. WhatsMenu separa y calcula automáticamente lo que consumió cada comanda, permitiendo cobrar individualmente a quien se va antes del cierre de mesa, todo sin errores.",
  "ordering_system": "El Sistema de Pedidos",
  "allows_your_customer": "Permite a tu cliente elegir el día y hora para recibir su pedido.",
  "allows_customer_they_wish": "Permite que el cliente elija el día y hora que desea recibir su pedido.",
  "you_can_sell_24h": "Puedes vender las 24h, incluso con tu establecimiento cerrado.",
  "prevents_setbacks": "Evita contratiempos como que el cliente no esté disponible para recibir y el repartidor pierda el viaje.",
  "advantages": "Ventajas",
  "configure_days_establishment": "Configura los días y horarios aceptados por el establecimiento.",
  "customer_best_time_for_them": "El cliente elige el mejor horario para él",
  "helps_improve": "Ayuda a mejorar la logística de entrega",
  "speak_with_consultant": "Hablar con un consultor ahora",
  "must_be_between": "El valor debe estar entre 0.49 y 0.99",
  "acess": "Accede",
  "delete_addresses": "Eliminar direcciones",
  "addresses_deleted": "¡Direcciones eliminadas con éxito!",
  "control_of": "Control de",
  "error_deleting_addresses": "Error al eliminar direcciones. Consulta la consola para más detalles.",
  "user": "Usuario",
  "sucess_updated": "actualizado con éxito",
  "something_wrong": "Algo salió mal",
  "talk_it_team": "Habla con el equipo de TI",
  "user_profile": "Perfil del usuario",
  "profile": "Perfil",
  "asaas_account_disconnected": "Cuenta Asaas desvinculada del perfil",
  "unable_disconnect_asaas_account": "No se pudo desvincular la cuenta Asaas del perfil",
  "additionals": "Adicionales",
  "there_no_services_generate": "No hay servicios para generar",
  "boleto_generated": "Boleto generado con éxito",
  "issue_add_ons": "Emitir adicionales",
  "make_sure_boleto_generated": "Asegúrate de que se haya generado un boleto para esta factura",
  "invoice_settlement": "Liquidación de factura",
  "reset_security_key": "Restablecer clave de seguridad",
  "assign_support": "Asignar soporte",
  "acessing_user_account": "Accediendo a la cuenta del usuario",
  "logging_in": "Iniciando sesión...",
  "back_to_list": "Volver a la lista",
  "menu": "Menú",
  "client_contracted_menu_registration": "El cliente contrató el registro del menú",
  "printer": "Impresora",
  "client_purchased_printer": "El cliente compró una impresora",
  "user_data": "Datos del usuario",
  "salesperson": "Vendedor",
  "responsible_support": "Soporte responsable",
  "name": "Nombre",
  "no_name": "Sin nombre",
  "no_email": "Sin correo electrónico",
  "invalid_email": "Correo inválido",
  "owner_email_address": "Correo del dueño del establecimiento",
  "ssn_ein": "RFC",
  "no_ssn_ein": "Sin RFC",
  "invalid": "Inválido",
  "no_whatsapp": "Sin WhatsApp",
  "full_name": "Nombre completo",
  "register_customer": "Registrar cliente",
  "registration_date": "Fecha de registro",
  "no_date": "Sin fecha",
  "select_payment_gateway_for_user": "Selecciona la pasarela de pago para el usuario antes de continuar",
  "login_attempts": "Intentos de inicio de sesión",
  "due_date": "Vencimiento",
  "payment_method": "Forma de pago",
  "card": "Tarjeta",
  "password": "Contraseña",
  "your_password": "Su contraseña",
  "passwords": "Contraseñas",
  "enter_new_password": "Introduce la nueva contraseña",
  "security_key": "Clave de seguridad",
  "reset": "Restablecer",
  "access_panel": "Acceder al Panel",
  "language": "Idioma",
  "country": "País",
  "brazil": "Brasil (R$)",
  "phone_footer": "Teléfono",
  "phone_abbreviation": "Tel.",
  "united_states": "Estados Unidos ($)",
  "portugal": "Portugal (€)",
  "united_kingdom": "Inglaterra (£)",
  "mexico": "México (MXN$)",
  "paraguay": "Paraguay (₲)",
  "select_language": "Seleccione el Idioma",
  "currency": "Moneda",
  "select_currency": "Seleccione la Moneda",
  "portuguese_brazil": "Portugués (Brasil)",
  "portuguese_portugal": "Portugués (Portugal)",
  "english_us": "Inglés (EE.UU.)",
  "english_uk": "Inglés (Reino Unido)",
  "english_jamaica": "Inglés (Jamaica)",
  "spanish_mexico": "Spanish (México)",
  "spanish_paraguay": "Spanish (Paraguay)",
  "english_grenada": "English (Grenada)",
  "english_ar": "English (Dubái)",
  "english_ireland": "Inglês (Irlanda)",
  "german_de": "Alemán (Alemania)",
  "internationalization": "Internacionalización",
  "not_registered": "No Registrado",
  "not_have_permission_adm": "No tienes permiso para acceder a una cuenta de Administrador",
  "clear_addresses": "Limpiar Direcciones",
  "clear": "Limpiar",
  "delete_addresses_customer": "¿Desea eliminar todas las direcciones o solo las que están fuera del área de entrega?",
  "outside_area": "Fuera del área",
  "no": "No",
  "yes": "Sí",
  "user_cancellation": "Cancelación de Usuario",
  "cancel_charges_user": "¿Cancelar los cargos de este usuario?",
  "version_next": "Versión Next",
  "test": "prueba",
  "activate": "Activar",
  "automatic_printing_browser": "Impresión automática desde el navegador",
  "observations": "Observaciones",
  "save": "Guardar",
  "title": "Título",
  "block_profile": "Bloquear Perfil",
  "value_whatsapp": "Valor en WhatsApp",
  "enable_shipping_mi": "Habilitar envío por KM",
  "double_sending_whatsapp": "Envío doble por WhatsApp",
  "enable_pix_online": "Habilitar Pix Online",
  "enable_online_card": "Habilitar Tarjeta Online",
  "remove_type_street": "¿Eliminar la calle de la dirección?",
  "old_pix": "Pix antiguo",
  "negotiation_fee": "Tasa de negociación",
  "days": "días",
  "expires_in": "Expira en",
  "expired_since": "Expiró hace",
  "disconnect_account_asaas": "Desvincular cuenta Asaas",
  "unlink": "Desvincular",
  "account_asaas": "Cuenta Asaas",
  "unlink_asaas_account": "¿Desea desvincular la cuenta Asaas de este cliente?",
  "quantity": "Cantidad",
  "issue": "Emitir",
  "number_installments": "Número de Cuotas",
  "invoices": "Facturas",
  "transaction_id": "ID de Transacción",
  "value": "Valor",
  "total_order": "Total de la Orden",
  "action": "Acción",
  "action_remove_user_the": "Esta acción eliminará al usuario del",
  "notice": "Aviso",
  "settlement": "Liquidación",
  "warning_financial_password": "¡ATENCIÓN! Debes registrar una Contraseña Financiera.",
  "warning_v2": "Para eso, accede al menú en la opción Configuraciones",
  "passwords_or": "Contraseñas o",
  "click_here": "Haz clic aquí",
  "enter_financial_password": "Ingresa tu Contraseña Financiera",
  "confirm": "Confirmar",
  "forgot_financial_password": "¿Olvidaste tu Contraseña Financiera?",
  "recover_password": "Recuperar Contraseña",
  "check_inbox_spam": "revisa tu 'bandeja de entrada' o 'spam'",
  "message_subject": "el mensaje con el asunto",
  "password_recovery": "Recuperación de Contraseña",
  "whastmenu": "Whatsmenu",
  "start_date": "Fecha de Inicio",
  "end_date": "Fecha Final",
  "search": "Buscar",
  "print": "Imprimir",
  "report": "Reporte",
  "product": "Producto",
  "products": "Productos",
  "product_m": "producto",
  "qty_sold": "Cant. Vendida",
  "total_amount": "Valor Total",
  "cash_summary": "RESUMEN DE CAJAS",
  "qty": "Cant.",
  "incomes": "Entradas",
  "table_closing": "Cierre de mesa",
  "table": "Mesa",
  "counter": "Mostrador",
  "request": "Pedido",
  "cancelled": "Cancelados",
  "cancelled_up": "CANCELADO",
  "cancelled_o": "Cancelado",
  "outflows": "Salidas",
  "n_orders": "Nº de Pedidos",
  "client": "Cliente",
  "average_ticket": "Ticket Promedio",
  "total_spent": "Total Gastado",
  "total_orders": "Total de pedidos",
  "total_amount_spent": "Monto total gastado",
  "customer_report": "Informe del cliente",
  "number_of_orders": "Cant. de Pedidos",
  "order_history": "Historial de Pedidos",
  "order_cod": "Cód. de Pedido",
  "change_for": "Cambio Para",
  "change": "Cambio",
  "payment": "Pago",
  "payment_abbreviation": "Pgo.",
  "all_customers": "Todos los Clientes",
  "filter": "Filtrar",
  "order_volume": "Volumen de Pedidos",
  "amount_consumed": "Valor Consumido",
  "no_results_found": "No se encontraron resultados",
  "no_customer_found": "No se encontró ningún cliente con ese nombre",
  "phone_number": "Teléfono",
  "customer_found": "Clientes Encontrados",
  "opening_time_must_closing": "¡La hora de apertura debe ser menor que la de cierre!",
  "time_will_not_take": "Este horario no surtirá efecto en",
  "following": "Siguiente",
  "day": "Día",
  "changing_existing_time": "considere cambiar un horario ya existente en el",
  "mentioned": "Mencionado",
  "please_select_day": "¡Por favor, seleccione un día!",
  "please_set_valid_time": "¡Por favor, defina una hora válida!",
  "operating_hours": "Horario de atención",
  "the_change_were": "Los cambios no se realizaron porque hay horarios inválidos. Corrija los campos destacados e intente nuevamente",
  "product_availability": "Disponibilidad de productos",
  "setting_operating_hours": "Configurando horarios de atención",
  "choose_days_times": "ELEGIR LOS DÍAS Y HORARIOS",
  "select_all": "Seleccionar Todos",
  "time_zone_successfully_changed": "Zona horaria cambiada con éxito",
  "from": "De",
  "until": "Hasta",
  "add": "Agregar",
  "open": "Abrir",
  "close": "Cerrar",
  "actions": "Acciones",
  "invalid_time": "Horario inválido",
  "if_work_overnight": "Si también trabajas de madrugada, es decir, después de medianoche, registra de esta manera",
  "pause": "Pausar",
  "unpause": "Reanudar",
  "delete": "Eliminar",
  "type": "Tipo",
  "priority": "Prioridad",
  "email_server": "Servidor de Correo",
  "content": "Contenido",
  "destination": "Destino",
  "address": "Dirección",
  "discount": "Descuento",
  "surchage": "Recargo",
  "fixed": "Fijo",
  "percentage": "Porcentaje",
  "type_of_fee": "Tipo de Tarifa",
  "type_of_value": "Tipo de Valor",
  "fee_amount": "Valor de la Tarifa",
  "copy": "COPIA",
  "successfully_duplicated": "se duplicó con éxito",
  "not_possible_duplicate": "No fue posible duplicar la categoría",
  "unable_duplicate_product": "No fue posible duplicar el producto",
  "category": "Categoría",
  "successfully": "con éxito",
  "the_category": "la categoría",
  "could_not": "No fue posible",
  "paused": "Pausado",
  "unpaused": "Reanudado",
  "the_product": "el producto",
  "sizes": "Tamaños",
  "size": "Tamaño",
  "edges_doughs": "Bordes y Masas",
  "flavors": "Sabores",
  "menu_information": "Información del Menú",
  "cat_standard": "Cat. Estándar",
  "qty_product": "Cant. Producto",
  "qty_add_ons": "Cant. Complementos",
  "qty_size": "Cant. Tamaños",
  "qty_edges_doughs": "Cant. Bordes/Masas",
  "qty_flavors": "Cant. Sabores",
  "you_edited": "Editaste",
  "items": "ítems",
  "cancel_edit_message": "¿Desea cancelar la edición?",
  "there_are_no": "No hay",
  "to_update": "para actualizar",
  "package_s": "Pedidos",
  "appointments": "Agendamientos",
  "appointment": "Agendamiento",
  "share_facebook": "Compartir en Facebook",
  "copy_clipboard": "Copiar al portapapeles",
  "copied": "Copiado",
  "link_sucess_copied": "Enlace copiado con éxito.",
  "unlink_link_copied": "No fue posible copiar el enlace, su navegador no es compatible.",
  "message_menu_adjust_prices": "El menú es tu vitrina de productos en WhatsMenu. Aquí puedes crear categorías, agregar ítems, complementos y opcionales, definir disponibilidad y ajustar precios.",
  "add_category": "Agregar Categoría",
  "reorder_menu": "Reordenar Menú",
  "search_g": "Buscar",
  "search_place": "Buscar...",
  "complements": "Complementos",
  "complement": "Complemento",
  "pizza_flavors": "Sabores de Pizza",
  "duplicate": "Duplicar",
  "edit": "Editar",
  "stock": "Inventario",
  "low": "Bajo",
  "out_stock": "Agotado",
  "edit_cover": "Editar Portada",
  "add_size": "Agregar Tamaño",
  "add_item": "Agregar Ítem",
  "add_complements": "Agregar Complemento",
  "edit_flavors": "Editar Sabores",
  "cancel_edit": "Cancelar Edición",
  "prices": "Precios",
  "price": "Precio",
  "photo": "Foto",
  "discard_changes": "Descartar cambios",
  "enter_valid_value": "¡Por favor ingrese un valor válido!",
  "in_stock": "EN STOCK",
  "add_flavors_firt_pizza": "Para agregar sabores, primero crea un tamaño de pizza.",
  "add_flavors": "Agregar Sabores",
  "updated_now": "Actualizado(s) ahora",
  "flavors_will_be": "sabores serán",
  "flavor_will_be": "sabor será",
  "please_wait": "Espere por favor...",
  "please_wait_n": "Espere",
  "edit_products": "Editar Productos",
  "products_will_be": "productos serán",
  "product_will_be": "producto será",
  "no_results_your_search": "No hay resultados para tu búsqueda",
  "no_category_registred": "Ninguna categoría registrada",
  "add_items_bulk": "Agregar ítems en masa",
  "you_changing_promotional_price": "Estás cambiando el precio promocional del producto.",
  "system": "Sistema",
  "cash_detail": "Detalle de caja",
  "operator": "Operador",
  "image_preview": "Vista previa de imagen",
  "width": "Ancho",
  "height": "Alto",
  "complete": "Finalizar",
  "review_entered_data": "Por favor, revise los datos ingresados.",
  "confirm_financial_password": "Confirmar Contraseña Financiera",
  "financial_password": "Contraseña Financiera",
  "how_to_make": "Cómo Hacer",
  "updated": "actualizada",
  "updated_o": "actualizado",
  "created": "creada",
  "unable_delete_category": "No se pudo eliminar la categoría",
  "standard": "Estándar",
  "delete_category": "Eliminar la categoría",
  "review_data": "Revisar Datos",
  "details": "Detalles",
  "availability": "Disponibilidad",
  "select_category_model": "Seleccionar el modelo de categoría",
  "acai_ice_creams": "Açaís y Helados",
  "burgers": "Hamburguesas",
  "meal_boxes": "Cajas de Comida",
  "meal_boxes_size_options": "Cajas de comida con opciones de tamaño",
  "build_meal_box": "Arma tu caja de comida",
  "butcher_shop": "Carnicería",
  "produce_section": "Frutas y Verduras",
  "drinks": "Bebidas",
  "category_name": "Nombre de la Categoría",
  "invalid_category_name": "Nombre de categoría inválido",
  "characters": "Caracteres",
  "minimum_stock": "Stock Mínimo",
  "add_availability_hours": "Agregar Horario de Disponibilidad",
  "use_addons_another_item": "Usar complementos de otro ítem",
  "creating_addons": "Creando complementos",
  "shared_addons": "Complementos compartidos",
  "attention": "Atención",
  "attention_up": "ATENCIÓN",
  "all_changes_addon_affect_other_product": "Todos los cambios en este complemento afectarán a otros productos que lo usen",
  "link": "Vincular",
  "attention_addon_linked": "Atención, este complemento está vinculado a",
  "attention_addon_linked_v2": "cualquier cambio aquí afectará a los productos vinculados, excepto la eliminación.",
  "other": "otro",
  "view_linked_products": "Ver Productos Vinculados",
  "invalid_name": "Nombre inválido",
  "min_greater_max": "Mínimo debe ser al menos 1.",
  "max_less_min": "Máximo debe ser mayor que el mínimo",
  "mandatory_addon": "Complemento Obligatorio",
  "options": "Opciones",
  "please_enter_valid_value": "Por favor ingrese un valor válido",
  "always_available": "Siempre disponible",
  "enable_stock": "Habilitar Inventario",
  "created_o": "creado",
  "create": "Crear",
  "was_deleted_successfully": "se eliminó con éxito",
  "could_not_delete_flavor": "No se pudo eliminar el sabor",
  "you_really_want_delete": "¿Realmente desea eliminar?",
  "error": "error",
  "the_flavor": "el sabor",
  "flavor": "Sabor",
  "image_up_8": "Imagen de hasta 8MB",
  "add_image": "Agregar Imagen",
  "recomended_resolution_600": "resolución recomendada de 600x450",
  "please_valid_name": "Por favor, ingrese un nombre válido",
  "message_pause_sales": "Para pausar las ventas de este ítem, haz clic en el botón al lado. Si el botón está habilitado, el ítem no aparecerá en tu lista de platos.",
  "pause_sales": "Pausar Ventas",
  "resume_sales": "Reanudar Ventas",
  "created_successfully": "creado con éxito.",
  "updated_successfully": "actualizado con éxito.",
  "was_not_created": "no fue creado.",
  "was_not_updated": "no fue actualizado.",
  "deleted_successfully": "eliminado con éxito.",
  "could_not_delete": "No se pudo eliminar",
  "could_not_pause": "No se pudo pausar",
  "resumed_successfully": "reanudada con éxito",
  "paused_successfully": "pausada con éxito",
  "to_pause_sale_message": "Para pausar las ventas de este ítem, haz clic en el botón al lado. Si el botón está habilitado, el ítem no aparecerá en tu lista de platos.",
  "size_name_already_exists": "Ya existe un tamaño con este nombre",
  "the_size": "el tamaño",
  "update": "Actualizar",
  "message_delete_remove_another": "Para eliminar, es necesario borrar los sabores o agregar otro tamaño de pizza",
  "message_really_delete_size": "¿Deseas realmente eliminar el tamaño?",
  "message_could_not_delete": "No se pudo eliminar el tamaño",
  "edit_size": "Editar Tamaño",
  "cover": "Portada",
  "this_size_accepts": "Este tamaño acepta",
  "add_cover": "Agregar Portada",
  "message_cannot_invalid_times": "No se pueden realizar los cambios porque hay horarios inválidos. Corrige los campos destacados e intenta de nuevo",
  "review_not_allowed": "Revisa tus complementos, no se permite nombre vacío",
  "could_not_delete_product": "No se pudo eliminar el producto",
  "delete_the_product": "Eliminar el producto",
  "promotion": "Promoción",
  "activate_promotion": "Activar promoción",
  "button_enable_disable_promotion": "Usa el botón al lado para habilitar o deshabilitar la promoción.",
  "original_price": "Precio Original",
  "promotional_price": "Precio Promocional",
  "promotion_ends_in": "Termina en",
  "available_for": "Disponible para",
  "message_products_not_created": "Los productos no se crearon porque hay horarios inválidos. Corrige los campos destacados e intenta de nuevo",
  "products_created_successfully": "Todos los productos fueron creados con éxito.",
  "products_not_created": "Los productos no fueron creados.",
  "create_products_bulk": "Crear Productos en Masa",
  "shortcuts": "Atajos",
  "right_arrow": "Flecha Derecha",
  "left_arrow": "Flecha Izquierda",
  "next_step": "Siguiente Paso",
  "back_one_step": "Regresar un Paso",
  "create_products": "Crear Productos",
  "add_product": "Agregar Producto",
  "duplicate_product": "Duplicar Producto",
  "product_name": "Nombre del Producto",
  "table_price": "Precio en Mesa",
  "product_description": "Descripción del Producto",
  "duplicate_r": "Duplicar",
  "no_product_added": "Ningún producto agregado",
  "creating_products": "Creando Productos...",
  "reordered_successfully": "Reordenado con éxito",
  "could_not_reorder_items": "No se pudieron reordenar los ítems",
  "message_press_and_hold": "Presiona y mantén durante 1 segundo y arrastra los ítems a la posición deseada. Esta secuencia también se reflejará en tu tienda.",
  "reordegring_wait": "Reordenando, espera...",
  "you_any_categories_yet": "Aún no has registrado ninguna categoría.",
  "please_review_data": "Por favor, revisa los datos.",
  "review": "Revisión",
  "fee_shipping": "Envío Gratis",
  "fee_shipping_up": "ENVÍO GRATIS",
  "fee": "Tasa",
  "disc": "Desc.",
  "free": "Gratis",
  "be_determined": "A Consultar",
  "disabled": "Desactivada",
  "order_slip": "Comanda",
  "order_slips": "Comandas",
  "ssn": "CURP",
  "duration": "Duración",
  "delivery_date": "Fecha de Entrega",
  "no_time_up": "SIN HORARIO",
  "paid_up": "PAGADO",
  "coupon_used": "Cupón usado",
  "delivery": "Entrega",
  "coupon": "Cupón",
  "payment_in": "Pago en",
  "total_paid": "Total Pagado",
  "checkout": "Cierre de Pedido",
  "paid_online_up": "PAGADO ONLINE",
  "delivery_person": "Repartidor",
  "s_n": "S/N",
  "technology": "Tecnología",
  "missing": "Faltan",
  "waiter": "Mesero",
  "paid": "Pagado",
  "delivery_fee": "Costo de Entrega",
  "printing_error": "Error de impresión",
  "could_not_send_printing": "No se pudo enviar la copia para impresión.",
  "order_confirmation": "Confirmación del pedido",
  "could_not_print_order": "No se pudo confirmar la impresión del pedido",
  "change_date": "Cambiar Fecha",
  "pending_prints": "Impresiones Pendientes",
  "message_pending_print": "pedidos pendientes para impresión, ¿deseas imprimir estos pedidos?",
  "there_are": "Hay",
  "print_all": "Imprimir Todos",
  "could_not_play_sound": "No se pudo reproducir el sonido.",
  "printing_up": "IMPRIMIENDO",
  "cancel_order": "Cancelar Pedido",
  "reinstate_order": "Reactivar Pedido",
  "no_orders_print_up": "NO HAY PEDIDOS PARA IMPRIMIR",
  "order_preview": "Vista Previa del Pedido",
  "teste_print_order": "Pedido de Prueba de Impresión",
  "report_request": "Pedido de Reporte",
  "received": "Recibido",
  "preparation": "Preparación",
  "delivering": "Entregando",
  "served": "Servido",
  "ready_for_pickup": "Listo para Retirar",
  "speak_customer": "Hablar con el Cliente",
  "select": "Seleccionar",
  "add_address": "Agregar Dirección",
  "edit_address": "Editar Dirección",
  "filling_establishment_address": "Rellenando la Dirección del Establecimiento",
  "zip_code": "Código Postal",
  "invalid_zip_code": "Código Postal inválido",
  "number": "Número",
  "neighborhood": "Colonia",
  "city": "Ciudad",
  "complete_address": "Dirección completa",
  "confirm_location": "Confirmar ubicación",
  "confirm_and_fill_address": "Confirma y completa los detalles adicionales de tu dirección.",
  "enter_your_zip_code_for_address": "Ingresa tu código postal para encontrar la dirección.",
  "requesting_your_location": "Solicitando tu ubicación...",
  "address_found": "Dirección encontrada",
  "confirm_address": "Confirmar dirección",
  "enter_your_zip_code": "Ingresa tu código postal",
  "i_do_not_know_my_zip_code": "No conozco mi código postal",
  "save_address": "Guardar dirección",
  "choose_saved_address_or_create_new": "Elige una dirección guardada o crea una nueva para continuar con el pedido.",
  "use_my_location": "Usar mi ubicación",
  "no_saved_address_for_this_client": "No hay direcciones guardadas para este cliente.",
  "select_delivery_location": "Seleccionar ubicación de entrega",
  "inform_city_and_neighborhood_for_delivery": "Indica la ciudad y el barrio para calcular el costo de entrega.",
  "searching": "Buscando...",
  "complement_address": "Departamento, edificio, etc.",
  "delivery_to_your_address": "Entrega a tu dirección",
  "enter_registed_email_recover_password": "Ingresa tu correo registrado para recuperar tu contraseña",
  "your_email": "Correo registrado",
  "please_enter_valid_email": "Ingresa un correo válido",
  "email_sent_successfully": "Correo enviado con éxito",
  "send": "Enviar",
  "delivery_package": "DELIVERY/PEDIDOS",
  "change_order_date": "Cambiar Fecha del Pedido",
  "selected_date": "Fecha Seleccionada",
  "current_order_date": "Fecha Actual del Pedido",
  "distribution": "Distribución",
  "order_coder": "Código del Pedido",
  "no_order_selected": "Ningún Pedido Seleccionado",
  "go_back": "Volver",
  "pickup": "Recoger",
  "deliver": "Entregar",
  "no_items_this_date": "No hay ítems para esta fecha",
  "all": "Todos",
  "pending": "Pendientes",
  "marked_received": "Marcados como Recibidos",
  "local_delivery": "Entrega Local",
  "summary_of": "Resumen de",
  "your": "tus",
  "your_a": "tus",
  "filter_use": "Filtro en uso",
  "choose_date_summary": "Elige una fecha para el resumen",
  "printing": "Impresión",
  "selected_orders": "Pedidos Seleccionados",
  "regarding": "Referente a",
  "calendar_view": "Vista Calendario",
  "loading_orders": "Cargando pedidos...",
  "order_slip_fees": "Tarifas de Comanda",
  "fees": "Tarifas",
  "charge": "Cobrar",
  "next_confirm": "Siguiente/Confirmar",
  "back_cancel": "Volver/Cancelar",
  "proceed": "Continuar",
  "delivery_report": "Reporte de Repartidores",
  "qty_of_deliveries": "Entregas",
  "total_delivery_fees": "Tarifas",
  "delivery_report_r": "Reporte de Entregas",
  "code_order": "Cod. Pedido",
  "date": "Fecha",
  "discard": "Descartar",
  "pending_changes": "Cambios Pendientes",
  "you_whant_save_them": "Existen cambios no guardados, ¿deseas guardarlos?",
  "new": "Nuevo",
  "my_profile": "Mi Perfil",
  "delivery_drivers": "Repartidores",
  "tables": "Mesas",
  "no_active_waiter": "Ningún mesero activo",
  "message_register_waitr_enable": "Para registrar o habilitar un mesero existente ve a Configuración > Mesa > pestaña Meseros o haz clic en",
  "register_waiter": "Registrar Mesero",
  "coupons": "Cupones",
  "social_media": "Redes Sociales",
  "reports": "Reportes",
  "financial_report": "Reporte Financiero",
  "daily_orders": "Pedidos Diarios",
  "monthly_orders": "Pedidos Mensuales",
  "cash_register_closing": "Cierre de Caja",
  "best_sellers": "Más Vendidos",
  "customer_report_side": "Reporte de Clientes",
  "general": "General",
  "cash_registers": "Cajas",
  "domains": "Dominios",
  "payment_methods": "Métodos de Pago",
  "administrator": "Administrador",
  "support_bonus": "Bono de Soporte",
  "salesperson_report": "Reporte de Vendedores",
  "annual_report": "Reporte Anual",
  "updates": "Actualizaciones",
  "exit": "Salir",
  "support_hours": "De lunes a sábado",
  "settings": "Configuraciones",
  "phone": "Teléfono",
  "press": "Presiona",
  "order_already_printed": "El pedido ya fue impreso",
  "order_not_printed": "Pedido no impreso",
  "wait_order_printed": "Espera a que el pedido se imprima",
  "displaying": "Mostrando",
  "of": "de",
  "filter_o": "Filtro",
  "caption": "Leyenda",
  "order_list": "Lista de Pedidos",
  "message_download_whatsmenu_desktop": "Descarga ahora el NUEVO WhatsMenu Desktop",
  "message_less_work": "Menos Trabajo y Más Ventas",
  "message_virtual_assistant": "Asistente virtual para WhatsApp",
  "with_area_code": "Con LADA",
  "owner_cell_phone": "Celular del dueño del establecimiento",
  "message_loyalty_program": "Programa de Fidelidad",
  "message_first_purchase": "Cupón de primera compra",
  "message_automated_sales_bot": "Bot de ventas automatizadas",
  "message_status_updates": "Envío de estados sin abrir ventanas",
  "message_download_app": "Descargar Aplicación",
  "donwload_the_whatsmenu": "Descarga el WhatsMenu Desktop",
  "message_download_whatsmenu_printers": "Descarga ahora el Nuevo WhatsMenu para Impresoras",
  "message_automatic_printing_mobile": "Impresión automática en el celular",
  "message_printing_multiple_printers": "Impresión en múltiples impresoras",
  "message_copy_printing": "Impresión de copias",
  "message_download_gplay": "Descargar desde Google Play",
  "message_downlaod_whatsmenu_printers": "Descarga el WhatsMenu para Impresoras",
  "message_audio_disabled": "Audio deshabilitado. Por favor interactúa con la pantalla para habilitarlo.",
  "message_monthly_invoice_available": "¡Factura mensual disponible para pago! Haz clic aquí.",
  "message_menu_locked": "¡Tu menú puede estar bloqueado debido a la falta de pago de la mensualidad! Haz clic aquí.",
  "overview_pos_pizza_addons": "Resumen del PDV y Adicionales de Pizza en WhatsMenu",
  "how_to_register_customer_pos": "Cómo registrar un cliente en el PDV",
  "guide_placing_order_pos": "Guía paso a paso para realizar un pedido vía PDV",
  "how_to_update_customer_information_pos": "Cómo modificar la información del cliente vía PDV",
  "guide_opening_cash_register": "Guía paso a paso para apertura de caja",
  "guide_closin_cash_register": "Guía paso a paso para cierre de caja",
  "cash_register_closing_reports": "Informes de cierre de caja",
  "how_place_order_counter_pos": "Cómo hacer un pedido para recoger en mostrador vía PDV",
  "reordering_customers_orders": "Repetición de pedidos anteriores en pocos clics",
  "place_order_pizza_pos": "Cómo hacer un pedido de pizza con 2 o más sabores, bordes y adicionales vía PDV",
  "how_create_tables": "Cómo crear mesas",
  "guide_registering_pizza_crusts": "Guía paso a paso para registrar pizzas con bordes y complementos",
  "pos": "PDV",
  "internet_connection_lost": "Tu conexión a Internet se ha perdido, verifica tu conexión.",
  "internnet_connection_reestablished": "Tu conexión a Internet se ha restablecido.",
  "register_your_customers_quickly_easily": "Registra a tus clientes y realiza pedidos de manera más ágil y sencilla.",
  "repeat_your_customer_clicks": "Repite el último pedido del cliente en solo 2 clics.",
  "cash_register_simply": "Apertura y cierre de caja con informes increíbles.",
  "gain_extra_speed": "Gana más velocidad en la atención de las mesas.",
  "support_more_information": "La mensualidad de tu plan completo venció y no identificamos el pago. Contacta al soporte para más información.",
  "dear_customer": "Estimado Cliente,",
  "have": "tienen",
  "not_have": "no tienen",
  "new_orders": "nuevos pedidos.",
  "go_to_orders": "Ir a pedidos",
  "general_settings": "Configuraciones Generales",
  "need_help": "¿Necesitas ayuda?",
  "you": "Tú",
  "copied_clipboard": "Copiado al portapapeles",
  "copy_n": "Copiar",
  "browser_not_have_copy": "Tu navegador no permite copiar",
  "cashback_status": "Estado del Cashback",
  "cashback_configuration": "Configuración de Cashback",
  "loyalty": "Fidelidad",
  "percentage_of": "Porcentaje de",
  "percentage_up": "PORCENTAJE",
  "validity": "Validez",
  "days_n": "Días",
  "in_days": "En días",
  "how_to_configure_cashback": "Cómo configurar el Cashback en WhatsMenu",
  "activate_cashback": "Activar Cashback",
  "promotion_link": "Enlace de promoción",
  "profile_information": "Información del Perfil",
  "store_name": "Nombre de la Tienda",
  "enter_store_name": "Ingresa el nombre de la tienda",
  "enter_slug": "Ingresa tu slug",
  "contact_phone_number": "Teléfono de contacto",
  "enter_contact_phone": "Ingresa el teléfono de contacto",
  "contact": "Contacto",
  "message_phone_number_will": "Este teléfono solo estará disponible para clientes con pedidos en curso.",
  "enter_store_description": "Ingresa la descripción de tu tienda",
  "minimum_delivery_order": "Pedido Mínimo para Entrega",
  "minimum_order_excluding_delivery": "Valor mínimo de pedido sin incluir la tarifa de entrega.",
  "minimum_order_pickup": "Pedido Mínimo para Recoger en el Local",
  "minimum_order_pickup_delivery": "Valor mínimo de pedido sin incluir la tarifa de entrega.",
  "preview_your_store": "Vista previa de tu tienda",
  "preview": "Vista Previa",
  "open_n": "Abierto",
  "calculate": "Calcular",
  "store_color": "Color de la Tienda",
  "wait_time": "Tiempo de Espera",
  "establishment": "Establecimiento",
  "store_layout": "Diseño de la Tienda",
  "shipping": "Envío",
  "congratulations": "Felicidades",
  "message_few_steps_organized": "En pocos pasos tendrás una atención ágil y organizada con tu",
  "digital_menu": "Menú Digital",
  "basic_details_establishment": "Rellena ahora los datos básicos de tu establecimiento.",
  "filling_profile": "Rellenando perfil",
  "restaurant_address": "Dirección del restaurante",
  "message_plan_not_include_delivery": "Tu plan actual no incluye la funcionalidad de Delivery o Pedidos/Reservas. Contacta al soporte para más detalles.",
  "closing_scheduled_time": "Cierre fuera del horario programado",
  "reopening_date": "Fecha de Reapertura",
  "time_zone": "Zona Horaria",
  "select_time_zone": "Selecciona tu zona horaria",
  "now": "Ahora",
  "add_business_hours": "Agregar Horario de Funcionamiento",
  "store": "Tienda",
  "closed_a": "cerrada",
  "open_a": "abierta",
  "monday": "Lunes",
  "tuesday": "Martes",
  "wednesday": "Miércoles",
  "thursday": "Jueves",
  "friday": "Viernes",
  "saturday": "Sábado",
  "sunday": "Domingo",
  "delivery_fees": "Tarifas de Entrega",
  "shipping_neighborhood": "Envío por barrio",
  "shipping_by_mi": "Envío por KM",
  "mile": "Kilómetro",
  "delivery_type_change_to": "Tipo de entrega cambiado a",
  "loading": "Cargando...",
  "delivery_type": "Tipo de Entrega",
  "by_mile": "Por Kilómetro",
  "reset_fees": "Restablecer Tarifas",
  "message_fee_deleted": "Si cambias la forma de tarifa, todas las tarifas actuales serán eliminadas",
  "message_really_change_fee": "¿Realmente deseas cambiar la forma de tarifa?",
  "by_neighborhood": "Por Barrio",
  "neighborhood_name": "Nombre del Barrio",
  "neighborhood_cannot_duplicated": "El barrio no puede estar duplicado",
  "to_be_confirmed": "Por confirmar",
  "neighborhood_added": "Barrio añadido",
  "city_and_neighborhood_added": "Ciudad y barrio añadidos",
  "neighborhood_deleted": "Barrio eliminado",
  "city_deleted": "Ciudad eliminada",
  "time_minutes": "Tiempo en Minutos",
  "changes_made_successfully": "Cambios realizados con éxito",
  "unexpected_try_again": "Ocurrió algo inesperado. Por favor, intenta nuevamente",
  "success": "Éxito",
  "online_payment_automatic": "Pago en Línea - Automático",
  "stripe_international_payments": "Pagos Internacionales",
  "stripe_international_payments_description": "Acepta tarjetas globales, Apple Pay y Google Pay con aprobación automática de pedidos.",
  "asaas_logo_alt": "Logo Asaas",
  "message_avoid_fraud_errors": "Evita fraudes, errores y retrasos al verificar comprobantes en la app del banco.",
  "asaas_terms_use": "Términos de uso Banco Asaas",
  "complete_activation_account": "Atención: completa la activación de tu cuenta",
  "acess_email": "Accede al correo electrónico",
  "message_open_asaas_email": "Abre el correo de Asaas y haz clic en el enlace para crear tu contraseña bancaria.",
  "message_sent_sms_token": "Enviamos el SMS con el token a",
  "account_creation_details": "Datos de la Cuenta Creada",
  "branch": "Agencia",
  "account_label": "Cuenta",
  "acess_asaas_account": "Accede a tu cuenta Asaas",
  "termis_of_use": "Términos de uso",
  "webhooks": "Webhooks",
  "webhook": "Webhook",
  "unable_fetch_webhook_status": "No se pudieron obtener los estados de los webhooks",
  "webhook_updated_successfully": "Webhook actualizado correctamente",
  "unable_update_webhook_status": "No se pudieron actualizar los estados de los webhooks",
  "confirm_change": "Confirmar cambio",
  "webhook_confirm_message": "¿Deseas {{action}} el webhook <b>{{name}}</b>?",
  "online_payment": "Pago en Línea",
  "payment_on_delivery_card": "Pago contra Entrega - Terminal",
  "payment_on_delivery": "Pago contra Entrega",
  "automate_your_payments": "Automatiza la recepción de tus cobros",
  "activate_this": "Activar Esto",
  "up_two_business_days": "Hasta 2 días hábiles",
  "acess_detailed_statements_asaas": "Nota: accede a tu app Banco Asaas para el estado de cuenta detallado.",
  "enable_surcharge_discount": "Habilitar Recargo/Descuento",
  "disabled_o": "Desactivado",
  "activated": "Activado",
  "card_network": "Red de Tarjetas",
  "add_card_network": "Agregar Red de Tarjetas",
  "key_type": "Tipo de Clave",
  "key": "Clave",
  "invalid_pix": "Pix inválido",
  "money": "Efectivo",
  "pix": "Pix",
  "picpay": "PicPay",
  "credit_card": "Tarjeta de Crédito",
  "credit": "Crédito",
  "debit": "Débito",
  "meal_voucher": "Vale Comida",
  "food_voucher": "Vale Alimentación",
  "month": "Mes",
  "year": "Año",
  "january": "Enero",
  "february": "Febrero",
  "march": "Marzo",
  "april": "Abril",
  "may": "Mayo",
  "june": "Junio",
  "july": "Julio",
  "august": "Agosto",
  "september": "Septiembre",
  "october": "Octubre",
  "november": "Noviembre",
  "december": "Diciembre",
  "search_for": "Buscar por",
  "summary": "Resumen",
  "detailed_summary": "Resumen Detallado",
  "number_orders": "Cantidad de Pedidos",
  "no_fees": "Sin Tarifas",
  "no_deliverys": "Sin Entregas",
  "deliverys": "Entregas",
  "number_deliveries": "Cantidad de Entregas",
  "total_sales_and_coupons": "Total de ventas del período - Total de cupones (Desconsiderando tasas/descuentos de pago)",
  "products_total": "Total acumulado de productos",
  "tax_delivery_total": "Total acumulado de tarifas de entrega",
  "period": "Período",
  "total_period": "Total do Período",
  "notes": "Notas",
  "total_canceled": "Total Cancelado",
  "number_canceled_orders": "Cantidad de Pedidos Cancelados",
  "total_fees": "Total de Tarifas",
  "no_fees_period": "Sin tarifas en este período",
  "fixed_amount": "MONTO FIJO",
  "fixed_amount_n": "Monto Fijo",
  "payment_methods_n": "Métodos de Pago",
  "waitstaff": "Meseros",
  "creation_date": "Fecha de Creación",
  "daily_report": "Reporte Diario",
  "monthly_report": "Reporte Mensual",
  "delivery_registration": "Registro de Repartidores",
  "error_deleting_delivery_person": "Error al eliminar repartidor",
  "error_pausing_activating": "Error al pausar/activar repartidor",
  "error_editing_delivery_person": "Error al editar repartidor",
  "delivery_person_name": "Nombre del Repartidor",
  "enter_delivery_person": "Ingresa el nombre del Repartidor",
  "enter_whatsapp_number": "Ingresa el número de WhatsApp",
  "registered_delivery": "Repartidores Registrados",
  "fill_all_fields": "Por favor, completa todos los campos.",
  "coupon_management": "Gestión de Cupones",
  "coupon_code": "Código del Cupón",
  "coupon_already_exists": "Este cupón ya existe",
  "coupon_invalid_chars": "No se permiten caracteres especiales",
  "coupon_allowed_chars_hint": "Solo letras, números, guión (-) y guión bajo (_)",
  "coupon_code_valid": "Código disponible",
  "offer_type": "Tipo de Oferta",
  "coupon_type": "Tipo de Cupón",
  "first_purchase": "Primera Compra",
  "discount_amount": "Valor de Descuento",
  "minimum_amount": "Monto Mínimo",
  "code": "Código",
  "unable_create_the_coupon": "No fue posible crear el cupón",
  "coupon_not_created": "Cupón no creado.",
  "status_coupon": "Estado del Cupón",
  "actives": "activos",
  "for_orders": "para pedidos",
  "inactive": "desactivados",
  "successfully_deleted": "eliminado con éxito",
  "delete_coupon": "Eliminar cupón",
  "business_offer_deliveries": "Tu negocio realiza entregas",
  "customer_pick_up_order_onsite": "El cliente puede recoger el pedido en el lugar",
  "cash_register": "Caja",
  "active_cash_management": "Activar gestión de caja",
  "message_currently_open_cash": "Tienes cajas abiertas actualmente. Por favor, ciérralas en",
  "before_register_management": "antes de cambiar la gestión de cajas",
  "customers": "Clientes",
  "display_date_birth": "Mostrar fecha de nacimiento",
  "require_date_birth": "Obligar fecha de nacimiento",
  "default_texts": "Textos Predeterminados",
  "changing_default_text_observations": "Cambiando texto predeterminado de observaciones",
  "product_note": "Observación del Producto",
  "example_no_mayonnaise": "Ej.: Sin mayonesa, sin ensalada, etc...",
  "pizza_note": "Observación de Pizza",
  "leave_any_note_product_here": "Deja aquí cualquier observación del producto.",
  "message_client": "Hola [NOMBRE], ¿Cómo estás?",
  "status_received": "Estado Recibido",
  "you_order_production": "¡[NOMBRE], tu pedido ya está en producción!",
  "status_delivering": "Estado Entregando",
  "yay_order_already_way": "¡Obaaa, [NOMBRE], tu pedido ya está en camino!",
  "status_pickup": "Estado Retirar",
  "finished": "Terminado",
  "order_ready_pickup": "¡Obaaa, [NOMBRE], tu pedido ya está listo para recoger!",
  "order_status_pos": "Estado del pedido en PDV",
  "order_successfully_placed": "¡[NOMBRE], pedido realizado con éxito, sigue el estado de tu pedido abajo!",
  "greeting_message": "Mensaje de saludo",
  "message_hello": "¡Hola [NOMBRE]!",
  "welcome_to": "Bienvenido a",
  "check_menu_order": "Consulta nuestro menú para hacer tu pedido",
  "exclusive_offers": "Ofertas exclusivas para pedidos en el enlace",
  "team": "Equipo",
  "use_a_printer": "Usar impresora",
  "group_order_printing": "Agrupar ítems de pedidos para impresión",
  "print_test": "Prueba de impresión",
  "test_print": "Probar impresión",
  "printer_driver": "Controlador de Impresión",
  "others": "Otros",
  "printing_app": "Aplicación de impresión",
  "print_width": "Ancho de impresión",
  "letters": "Letras",
  "small": "Pequeña",
  "large": "Grande",
  "copies": "Copias",
  "necessary_whatsmenu_android_installed": "Necesario tener instalada la app WhatsMenu Impresora 2.0 (Solo Android)",
  "pizza_options": "Opciones de Pizzas",
  "assign_price_most_expensive": "Asignar valor del más caro",
  "different_crusts_each_flavor": "Permitir bordes para cada sabor",
  "allow_each_flavor": "Permitir complementos para cada sabor",
  "stock_options": "Opciones de Inventario",
  "display_out_of_stock_product_addons": "Mostrar estado de 'agotado' en productos y complementos pausados",
  "hide_ssn_receipt": "Ocultar opción de CPF/CNPJ en el recibo",
  "description_top_product_page": "Mostrar foto y descripción del producto en la parte superior de la página del producto",
  "activate_catalog_mode_delivery": "Activar modo catálogo en delivery - No se podrá finalizar la compra, solo visualizar productos.",
  "activate_catalog_the_table": "Activar modo catálogo en mesa - No se podrá finalizar la compra, solo visualizar productos.",
  "automations": "Automatizaciones",
  "ignore_products_and_categories_availability": "¿Ignorar la disponibilidad de horario del producto y la categoría?",
  "send_status_page_pos_customer": "¿Deseas enviar la página de estado en PDV al cliente?",
  "only_indentification": "Solo la identificación",
  "label": "Etiqueta",
  "saving": "Guardando...",
  "are_no_pending_changes": "No hay cambios pendientes",
  "no_changes": "Sin Cambios",
  "saved": "Guardado",
  "saved_successfully": "Guardado con éxito.",
  "order_date": "Fecha del Pedido",
  "tomorrow": "Mañana",
  "today": "Hoy",
  "deliver_pickup": "Entrega/Recogida",
  "delivery_e": "Entrega Delivery",
  "closed_o": "Cerrado",
  "receive_orders_from": "Para recibir pedidos de",
  "enable_options_the_settings_for": "habilita las opciones en la configuración de",
  "printed": "Imp",
  "are_no_orders_moment": "No hay pedidos en este momento",
  "hours": "Horarios",
  "review_delivery_hours": "Por favor, revisa el horario de entregas.",
  "changes_saved": "Cambios guardados con éxito.",
  "not_saved": "No guardado",
  "unable_save_check_connection": "No fue posible guardar los cambios, verifica tu conexión.",
  "no_changes_to_save": "No hay cambios para guardar",
  "delivery_type_activated": "Es necesario tener al menos un tipo de entrega activado",
  "pickups": "Recogidas",
  "deliveries_pickups": "Entregas/Recogidas",
  "delivery_types_must_one_activated": "Los tipos de entrega deben tener al menos uno activado",
  "activate_orders": "Activar Pedidos",
  "delivery_scheduling": "Programación de entregas",
  "order_settings": "Configuración de Pedidos",
  "pickup_onsite": "Recoger en el lugar",
  "allow_onesite_pickups": "Permitir recogidas en el lugar",
  "allow_delivery_services": "Permitir entregas a domicilio",
  "make_available": "Disponibilizar",
  "starting_from": "a partir de",
  "allow": "Permitir",
  "for_day": "para el día",
  "within": "en hasta",
  "group": "Agrupar",
  "every": "cada",
  "preparationTime": "Tiempo de Preparación",
  "minutes": "Minutos",
  "max_of": "Máx. de",
  "per_day_from": "por día de 1 a 1000",
  "per_hour": "por horario",
  "display_menu_as": "Mostrar en el menú como",
  "minimum_for_delivery": "Mínimo para entrega",
  "minimum_for_pickup": "Mínimo para recogida",
  "register_order_cash_register": "Registrar pedidos en caja",
  "on_day_ordered": "En el día que se pidió",
  "on_delivery_day": "En el día de entrega",
  "availability_of": "Disponibilidad de",
  "dates_not_be_available": "Fechas en las que no habrá servicio",
  "select_special_dates": "Seleccione las fechas especiales en las que no habrá servicio",
  "select_a_date": "Seleccione una fecha",
  "defined_dates": "Fechas definidas",
  "remove": "Eliminar",
  "values": "Valores",
  "minimum_order_for_pickup": "Pedido mínimo para recogida en el local",
  "table_name_already_exists": "Ya existe una mesa con este nombre",
  "create_table": "Crear mesa",
  "enter_valid_name": "Por favor ingrese un nombre válido",
  "new_table": "Nueva mesa",
  "creating_table": "Creando mesa",
  "using_table_system": "Usando sistema de mesas",
  "table_name": "Nombre de la mesa",
  "cancel": "Cancelar",
  "available": "Disponible",
  "occupied": "Ocupada",
  "paused_a": "Pausada",
  "selected": "Seleccionada",
  "you_haven_registered_tables": "Aún no has registrado ninguna mesa",
  "how_close_entire_table": "Cómo cerrar la mesa completa",
  "how_close_individual": "Cómo cerrar comandas individuales",
  "table_settings": "Configuración de mesa",
  "fee_name_already_exists": "Ya existe una tarifa con este nombre.",
  "fee_name_cannot_empty": "El nombre de la tarifa no puede estar vacío.",
  "enter_value_greater_than": "Ingrese un valor mayor que",
  "add_fee": "Agregar tarifa",
  "created_successfully_a": "creada con éxito",
  "activate_fee": "Activar tarifa",
  "automatic_charge": "Cobro automático",
  "changed_successfully": "cambiado con éxito",
  "delete_fee": "Eliminar tarifa",
  "deleted_successfuly": "eliminado con éxito",
  "register_waitstaff": "Registrar mesero",
  "update_waitstaff": "Actualizar mesero",
  "create_waitstaff": "Crear mesero",
  "edit_waitstaff": "Editar mesero",
  "delete_waitstaff": "Eliminar mesero",
  "deleted_successfully_o": "eliminado con éxito",
  "restrict_menu": "Restringir menú",
  "unable_retrieve_menu_information": "No fue posible obtener la información del menú, intente de nuevo",
  "creating_fees": "Creando tarifas",
  "fee_name": "Nombre de la tarifa",
  "fee_already_exists": "Esta tarifa ya existe",
  "type_charge": "Tipo de cobro",
  "enter_number_greater_than": "Ingrese un número mayor que",
  "charge_automatically": "Cobrar automáticamente",
  "deactive": "Desactivar",
  "registering_waitstaff": "Registrando mesero",
  "placing_order_waiter": "Haciendo un pedido como mesero",
  "placing_pizza_order_waiter": "Haciendo un pedido de pizza como mesero",
  "waitstaff_name": "Nombre del mesero",
  "permission": "Permiso",
  "manager": "Gerente",
  "allow_orders": "Permitir pedidos",
  "register": "Registrar",
  "categories": "Categorías",
  "select_categories_waiter_permitted": "Seleccione las categorías a las que el mesero tendrá permiso para realizar pedidos",
  "call_waitstaff": "Llamar mesero",
  "keep_waitstaff_logged": "Mantener mesero conectado",
  "change_password": "Cambiar contraseña",
  "change_table": "Cambiar mesa",
  "enter_valid_name_different_current": "Por favor ingrese un nombre válido o diferente al actual",
  "delete_table": "Eliminar mesa",
  "activated_a": "activada",
  "pause_table": "Pausar mesa",
  "not_possible_pause_table_open": "No es posible pausar mesas con comandas abiertas",
  "table_options_up": "OPCIONES DE MESA",
  "points": "Puntos",
  "settings_up": "CONFIGURACIONES",
  "background": "Fondo",
  "resources": "Recursos",
  "register_cashier": "Registrar operador de caja",
  "registering_operator": "Registrando operador",
  "placing_order_operator": "Haciendo un pedido como operador",
  "operator_name": "Nombre del operador",
  "operators": "Operadores",
  "box_settings": "Configuración de caja",
  "delete_operator": "Eliminar operador",
  "edit_operator": "Editar operador",
  "create_operator": "Crear operador",
  "my_name_is": "Mi nombre es",
  "update_operator": "Actualizar operador",
  "register_operator": "Registrar operador",
  "there_failure_transaction": "Hubo una falla en la transacción",
  "change_card": "Cambiar tarjeta",
  "unable_change_payment_card": "No fue posible cambiar la tarjeta de pago",
  "redirecting_payment_page": "Redirigiendo a la página de pago",
  "difficulty_generating_payment_screen": "Estamos teniendo dificultades para generar la pantalla de pago, por favor intente de nuevo",
  "payment_gateway": "Pasarela de Pago",
  "no_payment_gateway_found": "No encontramos ninguna pasarela de pago",
  "select_option": "Seleccione una opción",
  "subscription": "Suscripción",
  "adding_your_subscription": "Estamos agregando su suscripción.",
  "failure_adding_your_subscription": "Hubo una falla al agregar su suscripción",
  "subscription_created_successfully": "Su suscripción fue creada con éxito",
  "failure_processing_try_again": "Hubo una falla en el procesamiento, por favor intente de nuevo",
  "ongoing_monthly_invoice": "Existe una factura mensual en curso.",
  "subscription_canceled": "Su suscripción está cancelada",
  "required": "Obligatorio",
  "required_complement_all_items_paused": "No se puede guardar: en \"{{name}}\", todos los ítems están pausados, pero el complemento es obligatorio. Activá al menos un ítem o desmarcá \"Complemento obligatorio\".",
  "additional": "Adicional",
  "monthly": "Mensual",
  "annual": "Anual",
  "semiannual": "Semestral",
  "monthly_payment": "Pago mensual con tarjeta",
  "add_registration_service": "Agregar servicio de registro",
  "with_printer": "Con impresora",
  "message_failure_payment_card": "Hubo una falla en el procesamiento del pago, verifique los datos y asegúrese de que haya límite disponible en su tarjeta",
  "payment_completed_successfully": "Pago efectuado con éxito, recargaremos la página.",
  "outstanding_invoices": "Facturas pendientes",
  "in_progress": "En progreso",
  "pay": "Pagar",
  "view_items": "Ver ítems",
  "cart": "Carrito",
  "check_items": "Revise los ítems",
  "start_registration": "Comenzar registro",
  "proceeding_whatsmenu_contact": "Al continuar, acepto que WhatsMenu me contacte por teléfono, correo electrónico o WhatsApp (incluyendo mensajes automáticos con fines comerciales).",
  "owner_name": "Nombre del dueño del establecimiento",
  "there_no_items_moment": "No hay ítems en este momento",
  "unique": "Única",
  "hello": "Hola",
  "after_payment_confirmation": "después de la confirmación de pago será redirigido y la página se recargará.",
  "proceed_payment": "Continuar al pago",
  "pending_pay": "Pago Pendiente",
  "refunded": "Reembolsado",
  "under_review": "En revisión",
  "awaiting_confirmation": "Esperando confirmación",
  "your_monthly_every_day": "Su mensualidad vence cada día",
  "each_month": "de cada mes",
  "services": "Servicios",
  "plan": "Plan",
  "generate_invoice": "Generar factura",
  "view_invoice": "Ver factura",
  "no_outstandigin_invoices_moment": "No hay facturas pendientes en este momento.",
  "paid_invoice_history": "Historial de facturas pagadas",
  "detail_table": "Detalle de mesa",
  "order_results": "Resultados del pedido",
  "displaying_orders_date_from": "Mostrando pedidos por fecha desde",
  "domain_registered_dns_registration": "¡Dominio registrado con éxito! Contacte al soporte para solicitar el registro DNS.",
  "domain_registered": "¡Dominio registrado con éxito!",
  "domain_already_registered": "Este dominio ya está registrado",
  "enter_valid_domain": "Por favor ingrese un dominio válido",
  "invalid_domain": "Dominio inválido",
  "domain_not_valid": "Este dominio no es válido, por favor ingrese un dominio válido",
  "domain_successfully_deleted": "Dominio eliminado con éxito",
  "delete_domain": "Eliminar dominio",
  "default_domain_successfully_changed": "Dominio predeterminado cambiado con éxito",
  "dns_entry": "Entrada DNS",
  "dns_entry_successfully": "Entrada DNS eliminada con éxito",
  "domain_settings": "Configuración de dominios",
  "after_registering_domain": "Después de registrar el dominio, será necesario apuntar a estos servidores",
  "domain": "Dominio",
  "domain_information": "Datos del dominio",
  "registered_domains": "Dominios registrados",
  "default_domain_cannot_deleted": "El dominio predeterminado no puede ser eliminado. Por favor contacte al soporte",
  "domain_com": "dominio.com",
  "default_domain": "Dominio predeterminado",
  "monthly_orders_report": "Reporte mensual de pedidos",
  "monthlys": "Mensuales",
  "daily_orders_report": "Reporte diario de pedidos",
  "box_closures": "Cierres de caja",
  "box_report": "Reporte de caja",
  "customer_report_v2": "Reporte de clientes",
  "best_selling_report": "Reporte de los más vendidos",
  "best_sellers_v2": "Los más vendidos",
  "click_here_view_details": "Haga clic aquí para ver el detalle",
  "summary_last_months": "Resumen de los últimos 12 meses",
  "summary_last_days": "Resumen de los últimos 30 días",
  "financial": "Financiero",
  "ph": "Tel",
  "dailys": "Diarios",
  "opening": "Apertura",
  "export_spreadsheet": "Exportar a hoja de cálculo",
  "creation": "Creación",
  "delivery_m": "entrega",
  "ready": "Listo",
  "spreadsheet": "Hoja de cálculo",
  "successfully_generated": "generada con éxito",
  "no_orders_found": "No se encontraron pedidos",
  "empty": "Vacío",
  "outputs": "Salidas",
  "daily": "Diario",
  "motoboys_daily": "Diaria",
  "motoboys_dailys": "Diarias",
  "deliveries_statement": "Extracto de entregas",
  "enter_daily_amount": "Ingrese el monto diario",
  "delivery_driver_signature": "Firma del repartidor",
  "operators_boxes": "Operadores de caja",
  "box_listing": "Listado de cajas",
  "opening_balance": "Saldo inicial",
  "opening_date": "Fecha de apertura",
  "closing_date": "Fecha de cierre",
  "box_closure": "Cierre de caja",
  "paid_a": "Pagado",
  "view_menu": "Ver Menú",
  "coin_t": "Moneda",
  "snack": "Vale de Comida",
  "food": "Vale de Alimentación",
  "order_printed_please_wait_finish": "Se está imprimiendo un pedido, por favor espere a que termine",
  "password_settings": "Configuración de contraseña",
  "access": "acceso",
  "security": "seguridad",
  "incorrect_current_password": "Contraseña actual incorrecta",
  "register_financial_password": "Registrar una contraseña financiera",
  "register_password": "Registrar contraseña",
  "change_financial_password": "Cambiar contraseña financiera",
  "register_password_financial": "Registrar contraseña financiera",
  "current_password": "Contraseña actual",
  "new_password": "Nueva contraseña",
  "confirm_password": "Confirmar contraseña",
  "change_access_password": "Cambiar contraseña de acceso",
  "recover_financial_password": "Recuperar contraseña financiera",
  "confirm_new_password": "Confirmar nueva contraseña",
  "authentication_failure": "Fallo de autenticación",
  "password_recovery_token": "Token de recuperación de contraseña expirado o inválido",
  "use_printer": "Usar impresora",
  "enable_stock_control": "Habilitar control de inventario",
  "stock_control": "Control de inventario",
  "layout_options": "Opciones de diseño",
  "tax_settings": "Configuraciones NFe",
  "edit_company": "Editar empresa",
  "add_company": "Agregar empresa",
  "configure_emission": "Configurar emisión",
  "company": "Empresa",
  "natural_person": "Persona Física",
  "company_name": "Razón social",
  "certificate": "e-CNPJ A1",
  "attach_certificate": "Adjuntar certificado modelo A1",
  "identification": "Identificación",
  "responsable": "Responsable",
  "accounting": "Contabilidad",
  "tokens": "tokens",
  "zelle": "Zelle",
  "twint": "Twint",
  "tax_documents": "Documentos fiscales",
  "attach_company_logo": "Adjuntar logo de la empresa",
  "trade_name": "Nombre comercial",
  "state_registration": "Registro estatal",
  "municipal_registration": "Registro municipal",
  "tax_regime": "Régimen tributario",
  "select_an_option": "Seleccione una opción",
  "simple_national": "Simples Nacional",
  "Excess_gross_revenue_sublimit": "Exceso de sublímite de ingresos brutos",
  "normal_regime": "Régimen normal",
  "email": "Correo electrónico",
  "ein": "CNPJ",
  "street": "Calle",
  "municipality": "Municipio",
  "fu": "UF",
  "responsible_name": "Nombre del responsable",
  "responsible_ssn": "CPF del responsable",
  "approval_token": "Token de homologación",
  "production_token": "Token de producción",
  "approval": "Homologación",
  "series": "Serie",
  "next_number": "Número siguiente",
  "id_approval_token": "ID token de homologación",
  "security_code_approval": "CSC homologación",
  "production": "Producción",
  "id_production_token": "ID token de producción",
  "security_code_production": "CSC",
  "advanced_settings": "Configuraciones avanzadas",
  "electronic_consumer_fiscal_note": "NFCe",
  "enable_offline_contingency": "Habilitar contingencia offline",
  "all_documents": "Todos los documentos",
  "send_email_to_recipient": "Enviar correo al destinatario",
  "discriminate_taxes": "Discriminar impuestos",
  "electronic_fiscal_note": "NFe",
  "show": "Mostrar",
  "auxiliary_document_for_the_electronic_fiscal_notes": "DANFSe",
  "show_badge_focus_efn_on_adefn": "Mostrar badge Focus NFe en DANFSe",
  "emission_ecfn": "Emisión NFCe",
  "whenever_necessary_you_can_manually_issue_in_addition_to_the_defined_standard": "cuando sea necesario podrá emitir manualmente además del estándar definido",
  "set_defaults_for_automatic_issuance_of_your_fiscal_notes": "Configure los valores predeterminados para la emisión automática de sus notas fiscales",
  "daily_average": "Promedio diario",
  "credit_machine": "Crédito máquina",
  "credit_online": "Crédito en línea",
  "debit_machine": "Débito máquina",
  "debit_online": "Débito en línea",
  "dont_miss_deadlines": "No pierda fechas límite",
  "we_will_send_the_fiscal_closing": "Enviaremos mensualmente el cierre fiscal (XML) a su contabilidad",
  "accountant_email": "Correo del contador",
  "additional_service": "Servicio adicional",
  "gratis": "Gratis",
  "for_shopkeeper": "para comerciante",
  "WM": "WhatsMenu",
  "plan_change": "Cambio de plan",
  "current_plan": "Plan actual",
  "plan_expiration": "Vencimiento del plan",
  "change_plan": "Cambiar plan",
  "security_password_registered": "Contraseña de seguridad registrada con éxito",
  "with": "con",
  "consult": "Consultar",
  "link_for_order_status": "Enlace para el estado del pedido",
  "chosen_date_earlier_current_date": "La fecha elegida es anterior a la fecha actual, por favor seleccione una fecha posterior.",
  "check_the_cvv": "Verifique el CVV",
  "check_card_details": "Verifique los datos de la tarjeta",
  "check_billing_address": "Verifique la dirección de facturación",
  "check_card_expiration_date": "Verifique la fecha de expiración de la tarjeta",
  "check_card_number": "Verifique el número de la tarjeta",
  "check_security_code": "Verifique el código de seguridad",
  "check_zip_code": "Verifique el código postal",
  "unable_register_your_order_try_again": "No se pudo registrar su pedido, por favor intente de nuevo",
  "system_identified_you_are_outside": "El sistema detectó que está fuera de nuestra área de cobertura, intente completar su pedido nuevamente",
  "swiss_french": "Franco Suizo (Fr.)",
  "swiss_french_chf": "Franco Suizo",
  "jamaican_dollar": "Dólar Jamaicano",
  "mexican_peso": "Peso Mexicano",
  "eastern_caribbean_dollar": "Eastern Caribbean Dollar",
  "integrations": "Integraciones",
  "stripe": "Stripe",
  "stripe_invalid_api_key": "Ingrese una API key válida.",
  "stripe_integration_saved_successfully": "Integración de Stripe guardada con éxito.",
  "stripe_integration_save_error": "No se pudo guardar la integración. Inténtelo de nuevo.",
  "stripe_logo_alt": "Logo de Stripe",
  "stripe_description_1": "Stripe es una plataforma global de infraestructura financiera que permite a restaurantes de todos los tamaños aceptar pagos en línea en todo el mundo.",
  "stripe_description_2": "Cree una cuenta y comience a aceptar pagos en múltiples monedas, sin contratos ni datos bancarios.",
  "stripe_international_currencies": "Monedas internacionales",
  "stripe_currency_flag_alt": "Bandera {{code}}",
  "stripe_connect_account": "Integrar mi cuenta de Stripe",
  "stripe_api_key_label": "API Key de Stripe",
  "stripe_api_key_placeholder": "sk_live_...",
  "stripe_currency_cad": "Dólar canadiense",
  "stripe_currency_eur": "Euro",
  "stripe_currency_mxn": "Peso mexicano",
  "stripe_currency_aud": "Dólar australiano",
  "stripe_currency_gbp": "Libra esterlina",
  "stripe_currency_nzd": "Dólar neozelandés",
  "stripe_currency_cnh": "Renminbi chino",
  "stripe_currency_jpy": "Yen japonés",
  "stripe_currency_usd": "Dólar estadounidense",
  "stripe_currency_chf": "Franco suizo",
  "stripe_currency_sek": "Corona sueca",
  "stripe_currency_hkd": "Dólar de Hong Kong",
  "stripe_currency_try": "Lira turca",
  "stripe_currency_krw": "Won surcoreano",
  "stripe_digital_wallets_title": "Google Pay y Apple Pay",
  "stripe_digital_wallets_description": "Stripe también acepta pagos a través de Google Pay y Apple Pay, ofreciendo a sus clientes una experiencia de pago rápida y segura.",
  "stripe_fees_title": "Transferencia de tarifas de Stripe",
  "stripe_fees_description": "Configure tarifas adicionales que se cobrarán automáticamente cuando el cliente pague a través de Stripe.",
  "stripe_fees_enable": "Cobrar tarifas de Stripe",
  "stripe_fees_enable_description": "Cuando está activado, las tarifas configuradas se agregarán al total del pedido en el checkout de Stripe.",
  "stripe_fees_fixed_label": "Tarifa fija",
  "stripe_fees_fixed_placeholder": "0.00",
  "stripe_fees_percentage_label": "Tarifa porcentual (%)",
  "stripe_fees_percentage_placeholder": "0.00",
  "stripe_fee": "Tarifa Stripe",
  "online_payment_s": "Pagos en Línea",
  "online_payment_description": "Evite fraudes, errores y retrasos al no tener que verificar comprobantes en la app del banco; el pedido llega al panel y el pago es seguro directo a su cuenta.",
  "fiscal_note_issuer": "Emisor de NFe y NFCe",
  "fiscal_note_issuer_description": "No pierda tiempo registrando facturas manualmente, defina automatizaciones y configure límites según su registro CNPJ.",
  "grove_nfe_description": "Emisión y Gestión Automática de Notas Fiscales",
  "automation_of_nfe": "Automatización NFC-e",
  "certificate_password": "Contraseña de su certificado Modelo A1",
  "set_the_environment": "Defina el entorno",
  "origin": "Origen",
  "not_received": "No recibido",
  "marketing_and_sales": "Marketing y Ventas",
  "we_integrate_your_store": "Integramos su tienda con las mejores herramientas de marketing y ventas del mercado, atraiga más clientes y venda mucho más con menos esfuerzo.",
  "own_website": "Sitio Web Propio",
  "disponibility": "Disponibilidad",
  "please_enter_valid_name": "Por favor ingrese un nombre válido",
  "image_up": "Imagen de hasta 8MB (resolución recomendada 600x450)",
  "share": "Compartir",
  "fill_all_required": "Complete todos los campos obligatorios",
  "billing": "Facturación",
  "result_orders": "Resultado Pedidos",
  "viewing_orders_by_date": "Mostrando pedidos por fecha de",
  "enable_original_image_size": "Activar tamaño original de la imagen",
  "cashback": "Cashback",
  "no_register": "Sin registro",
  "load_complements_wait": "Cargando complementos, por favor espere",
  "deactivated_delivery": "Desactivar Delivery",
  "hide_unity": "Deshabilitar cantidad",
  "Delivery_options": "Opciones de Delivery",
  "Profile_options": "Opciones de Perfil",
  "catalog_mode": "Modo Catálogo",
  "status_order": "Estado del Pedido",
  "completed": "Completado",
  "slug": "Slug",
  "clone_categories": "Clonar Categorías",
  "clone": "Clonar",
  "no_change_needed": "No necesita cambio de vuelto",
  "serivce_fee": "Cargo por Servicio",
  "customer_delivery_address": "Dirección de Entrega del Cliente",
  "not_informed": "No informado",
  "route_up": "RUTA",
  "payments_in": "Pagos en",
  "the_order_is_now_ready": "¡El pedido ya está listo para ser recogido! Aquí está el contacto del cliente",
  "if_you_need": "en caso de necesitar",
  "reference": "Referencia",
  "pickup_the_location": "Voy a recoger en el lugar",
  "table_request": "Pedido mesa",
  "possible": "Posible",
  "the_date_of_your_delivery": "La fecha de su entrega es",
  "sounds_notification": "Sonido de notificación de pedidos",
  "play_sound_delivery": "Activar sonido de pedidos delivery",
  "play_sound_eat_on_site": "Activar sonido de pedidos en sitio",
  "play_sound_table": "Activar sonido de pedidos mesa",
  "play_sound_package": "Activar sonido de pedidos encomienda",
  "closing": "Cierre",
  "mbway": "MBWay",
  "spin": "Spin",
  "unable_to_read": "No se pudo leer su ubicación, por favor verifique que los servicios de ubicación no estén bloqueados.",
  "address_covarage_area": "¡Su dirección está fuera de nuestra área de cobertura!",
  "register_open_24": "Hay una caja abierta por más de 24 horas y será cerrada.",
  "table_desactived": "Lo sentimos, esta mesa está actualmente desactivada.",
  "moment_table_not_avaible": "Actualmente, esta mesa no está disponible para nuevos pedidos.",
  "table_not_avaible_new_orders": "Actualmente, esta mesa no está disponible para nuevos pedidos.",
  "order_already_been_completed": "El pedido anterior ya fue completado. ¿Está aún en el restaurante o desea hacer un nuevo pedido para entrega?",
  "at_the_table": "Estoy en la mesa",
  "deliver_order": "Entregar pedido",
  "not_belong_this_table": "Este pedido no pertenece a esta mesa.",
  "store_closed": "¡TIENDA CERRADA!",
  "not_minimum_value": "Su pedido no alcanzó el valor mínimo de",
  "failed_validate_coupon": "Error al validar el cupón, por favor verifique su conexión.",
  "amount_not_include_delivery_fee": "Este valor total no incluye la tarifa de entrega.",
  "coupon_used_starting_from": "Este cupón solo puede usarse para compras a partir de",
  "closed_delivery": "CERRADO PARA ENTREGA",
  "unable_create_customer": "No se pudo crear el cliente. Por favor, intente nuevamente.",
  "selected_date_earlier_choose_later_date": "La fecha seleccionada es anterior a la fecha actual, por favor elija una fecha posterior.",
  "try_again_moment": "Ocurrió algo inesperado, por favor intente de nuevo más tarde.",
  "error_generate_qrcode": "No se pudo generar el código QR. Por favor intente nuevamente.",
  "payment_not_detected": "Pago no detectado. Por favor, verifique su aplicación bancaria.",
  "reloaded_page_message": "¡La página necesita ser recargada!",
  "name_and_last_name_and_phone_required": "Nombre, apellido y número de teléfono son obligatorios",
  "enter_your_details": "Ingrese sus datos",
  "enter_your_name": "Ingrese su nombre",
  "enter_your_whatsapp": "Ingrese su Whatsapp",
  "enter_your_date_of_birth": "Ingrese su fecha de nacimiento",
  "review_change_amount": "¡Revise el valor del cambio!",
  "no_internet_connection": "Sin conexión a Internet",
  "ifood_portal_orders": "Mensajeros en la nube subcontratados vía iFood",
  "disconnect_account": "Desconectar cuenta Asaas",
  "cancel_edits": "Cancelar edición",
  "option": "Opción",
  "toMiles": true,
  "Nenhum garçom ativo": "Ver Menú",
  "check_code": "Verifique el NPA",
  "enter_your_cpf": "Ingrese su CPF",
  "print_cash_report": "Imprimir reporte de caja",
  "cashier_open": "Caja abierta",
  "product_type": "Tipo de producto",
  "bulk": "Granel",
  "unit": "Unidad",
  "select_unit_measurement": "Seleccione la unidad de medida",
  "kg_value": "Valor por kilo",
  "l_value": "Valor por litro",
  "barcode": "Código de barras",
  "product_code": "Código del producto",
  "no_product_code": "Sin código de producto",
  "product_code_abbreviation": "Código Producto",
  "product_code_already_exists": "Ya existe un producto registrado con este código.",
  "pizza_product_code_already_exists": "No fue posible guardar: ya existe un producto o tamaño de pizza con este código.",
  "volume": "Volumen",
  "weight": "Peso",
  "select_product_will_be_sold": "Seleccione si el producto se venderá por unidad o a granel",
  "automatic_confirmation": "Confirmación automática",
  "manual_confirmation": "Confirmación manual",
  "unit_value": "Valor unitario",
  "alter_value": "Cambio de valor",
  "open_for_appointments": "Aberto para Agendamientos",
  "closed_for_appointments": "Fechado para Agendamientos",
  "open_for_package": "Aberto para pedidos programados",
  "closed_for_package": "Fechado para pedidos programados",
  "whatsMenuPro": {
    "this_app_is_better_than": "¡Esta APP es mejor que empleados, ya sea en la tienda o para entrega, toda la gestión ahora está automatizada!",
    "waiter_app_delivery": "APP DE MESERO, RUTA DE ENTREGA Y MUCHO MÁS.",
    "yes_i_want": "SÍ, QUIERO MÁS INFORMACIÓN",
    "i_want_information": "¡QUIERO INFORMACIÓN!",
    "aprroved_by": "Aprobado por más de",
    "restaurants_worldwide": "restaurantes en todo el mundo",
    "more_professionalism": "Más profesionalismo",
    "more_clients_sales": "Más clientes y más ventas...",
    "whatsMenuPro_transform_small": "WhatsMenu.PRO transforma pequeños restaurantes en poderosas máquinas de ventas:",
    "receive_orders_auto": "Recibe pedidos automáticamente sin necesidad de interactuar con los clientes.",
    "customers_will_not": "Los clientes ya no tendrán que esperar al mesero.",
    "no_extra_labor": "No se necesita mano de obra extra para recibir pedidos.",
    "automatic_priting": "Impresión automática de pedidos.",
    "never_lose_order": "Nunca más pierdas un pedido.",
    "reduce_to_zero": "Reduce errores en los pedidos a cero.",
    "increase_the_average": "Aumenta el ticket promedio y la frecuencia de compras.",
    "control_everything": "Controla todo automáticamente desde tu celular o computadora.",
    "the_features": "Las funciones que recibirás.",
    "the_most_complet": "La plataforma de restaurantes más completa y poderosa:",
    "virtual_attendant": "Atendente Virtual",
    "catalog_mode": "Modo Catálogo",
    "orders_delivery_scheduling": "Pedidos y Programación de Entregas",
    "counter_orders": "Pedidos en Mostrador",
    "order_manager": "Administrador de Pedidos",
    "pos_point_of_sale": "PDV - Punto de Venta",
    "reports_customers": "Reportes: Clientes, Productos, Ingresos, Inventario",
    "qr_code_table_delivery": "Código QR para Mesa, Entrega y Mostrador",
    "free_website": "Sitio Profesional Gratis",
    "app_waiter": "APP para Meseros",
    "delivery_manager": "Administrador de Entregas",
    "automatic_inventory_control": "Control Automático de Inventario",
    "domain_hosting": "Hospedaje de Dominio",
    "talk_to_attendant": "HABLE CON EL ATENDENTE",
    "those_who_use": "Quienes usan, recomiendan",
    "see_the_models": "Ve los modelos y haz",
    "test_order": "un pedido de prueba.",
    "talk_with_attendant": "Habla con el atendente",
    "still_afraid": "Pero aún tengo miedo",
    "wont_work": "de que no funcione, ¿y ahora?",
    "we_have_human_team": "Contamos con un equipo 100% humano, altamente capacitado para ayudarte en estos primeros pasos y siempre que lo necesites. Programaremos una videollamada de onboarding y te asistiremos con las configuraciones. ¡Te guiaremos en cada etapa!",
    "yes_i_wanna_help": "SÍ, QUIERO AYUDA",
    "days_of_satisfaction": "7 días de satisfacción",
    "or_your_money_back": "¡o te devolvemos tu dinero!",
    "i_belive_in_the_results": "Creo tanto en los resultados que WhatsMenu.PRO traerá para ti, que ofrezco una garantía de 7 días para probar. Si no estás satisfecho o te arrepientes por cualquier motivo, solo contáctame por WhatsApp y te reembolsaré el 100% de tu dinero.",
    "talk_with_us_on_WhatsApp": "Habla con nosotros por WhatsApp",
    "what_is_your_name": "¿Cuál es tu nombre?",
    "what_is_your_WhatsApp": "¿Cuál es tu WhatsApp?",
    "what_product_you_sell": "¿Qué producto vendes?",
    "Browse": "Navega",
    "how_works": "CÓMO FUNCIONA",
    "features": "FUNCIONES",
    "clients": "CLIENTES",
    "examples": "EJEMPLOS",
    "team": "EQUIPO",
    "support": "SOPORTE",
    "access_dashboard": "ACCEDER AL PANEL",
    "right_reserved": "Todos los derechos reservados.",
    "digital_menu": "MENÚ DIGITAL",
    "delivery": "ENTREGA",
    "call": "¡LLAMA AHORA!"
  },
  "logistics_management": "Gestión Logística",
  "logistics_description": "Elimina retrasos y errores de ruta, acompaña a todos tus repartidores en tiempo real en el mapa GPS, y ofrece una experiencia exclusiva en los pedidos de tus clientes.",
  "logistics_mottu": "Entregas rápidas y seguras",
  "printers": "Impresoras",
  "view": "Ver",
  "reload": "Recargar",
  "force_reload": "Forzar Recarga",
  "console": "Consola",
  "print_auto": "Imprimir Automáticamente",
  "custom": "Personalizado",
  "no_margin": "Sin Margen",
  "minimum_margin": "Margen Mínima",
  "scale": "Escala",
  "scale_print": "Escala de impresión",
  "scale_percentage": "Escala en porcentaje",
  "add_printer": "Agregar Impresora",
  "printers_available": "Impresoras Disponibles",
  "no_printer_available": "Ninguna Impresora Disponible",
  "select_printer": "Seleccione una Impresora",
  "select_printer_detail": "Seleccione una Impresora, si no desea impresión automática desmarque la casilla \"Imprimir Automáticamente\"",
  "paper_size": "Tamaño del Papel",
  "select_paper_size": "Seleccione el tamaño del papel",
  "legacy_printer": "Impresión legado",
  "config_ambient_printer": "Configurar ambientes",
  "paper_width": "Anchura del papel",
  "paper_width_detail": "Valor en milímetros (mm)",
  "copies_quantity": "Cantidad de Copias",
  "dashboard": "Panel de Control",
  "whatsapp_bot": "Bot de WhatsApp",
  "disabled_menu": "Menú Desactivado — Por favor, contacte con el Establecimiento.",
  "login": "Acceso",
  "forgot_password": "olvidé mi contraseña",
  "logout": "Salir",
  "pos_videos": "Vídeos PDV",
  "download_desktop_title": "Descarga ahora el NUEVO WhatsMenu Desktop",
  "download_desktop_subtitle": "Menos Trabajo y Más Ventas",
  "download_desktop_bot": "Asistente virtual para WhatsApp",
  "download_desktop_fidelity": "Programa de Fidelidad",
  "download_desktop_cashback": "Reembolso (CashBack)",
  "download_desktop_first_coupon": "Cupón para primera compra",
  "download_desktop_sales_bot": "Bot de ventas automatizadas",
  "download_desktop_no_tabs": "Envío de estado sin abrir pestañas",
  "download_app": "Descargar Aplicación",
  "how_to_use": "Ver cómo usar",
  "invoice_available": "Factura mensual disponible para pago. Haga clic aquí.",
  "payment_overdue": "Su menú puede ser bloqueado porque su mensualidad está atrasada. Haga clic aquí.",
  "tables_link": "Enlace de Mesas",
  "update_desktop_title": "Nuevo WhatsMenu Desktop",
  "update_desktop_message": "Más ligero y más rápido — Mayor eficiencia en el control de mensajes.",
  "update_desktop_button": "ACTUALIZA AHORA",
  "bot_step1": "Abre WhatsApp en tu celular.",
  "bot_step2.1": "Toca en",
  "bot_step2.2": "Más opciones",
  "bot_step2.3": "en Android o en",
  "bot_step2.4": "Configuración",
  "bot_step2.5": "en iPhone.",
  "bot_step3.1": "Toca en",
  "bot_step3.2": "Dispositivos vinculados",
  "bot_step3.3": "y luego en",
  "bot_step3.4": "Vincular un dispositivo.",
  "bot_step4": "Apunta tu celular a esta pantalla para escanear el código QR.",
  "connected": "Conectado",
  "disconnected": "Desconectado",
  "connection_error": "Error de conexión",
  "disconnect": "Desconectar",
  "try_again": "Intentar otra vez",
  "customer_service_bot": "Bot de atención",
  "bot_attention": "¡ATENCIÓN!",
  "phone_sync_warning": "Mantén la pantalla de tu celular encendida hasta que la pantalla de sincronización se cierre sola.",
  "loading_messages": "Cargando mensajes...",
  "print_env_config": "Configuración de Entorno de Impresión",
  "print_env_edit": "Edición de Entorno de Impresión",
  "print_type": "Tipo de Impresión",
  "fiscal_printer": "Impresión Fiscal",
  "production_printer": "Impresión de Producción de Pedido",
  "env_name": "Nombre del Entorno",
  "enter_env_name": "Ingrese el nombre del entorno",
  "prod_categories": "Categorías de Productos",
  "select_prod_category": "Seleccione las categorías de productos a incluir en la impresión.",
  "save_edit": "Guardar Edición",
  "environment": "Entorno",
  "print_env": "Entorno de Impresión",
  "env_register": "Registrar Entorno",
  "printer_config": "Configurar Impresoras",
  "edit_envs": "Editar Entornos de",
  "print_envs": "Entornos de impresión",
  "select_envs": "Seleccione los entornos que desea asignar a",
  "bot_send_menu": "Envío del menú por el bot",
  "bot_not_allow_attendant": "No permitir hablar con un asistente",
  "selected_item": "Ítem seleccionado",
  "selected_items": "Ítems seleccionados",
  "canceled_items": "Artículos cancelados",
  "select_state": "Seleccione el estado",
  "enter_the_address_number": "Ingrese el número de la dirección",
  "call": "¡LLAME AHORA!",
  "cpf_cnpj_on_the_receipt": "CPF/CNPJ en el comprobante",
  "cpf_invalid": "CPF inválido",
  "denmark": "Dinamarca (kr)",
  "dubai": "Dubái (د.إ)",
  "english_ie": "Inglés (Irlanda)",
  "enter_your_last_name": "Ingrese su apellido",
  "finland": "Finlandia (€)",
  "france": "Francia (€)",
  "germany": "Alemania (€)",
  "grenada": "Granada (EC$)",
  "invalid_cpf": "CPF inválido",
  "ireland": "Irlanda (€)",
  "italy": "Italia (€)",
  "jamaica": "Jamaica (J$)",
  "kg_or_l": "kg o L",
  "last_name": "Apellido",
  "norway": "Noruega (kr)",
  "now_accepting_scheduled_orders": "Abierto para programaciones",
  "out_for_delivery": "En reparto",
  "secret_number": "CPF",
  "enter_motoboys_secret_number": "Digite o CPF do Entregador",
  "spain": "España (€)",
  "support": "Soporte",
  "sweden": "Suecia (kr)",
  "switzerland": "Suiza (CHF)",
  "AF": "Afganistán",
  "AX": "Islas Åland",
  "AL": "Albania",
  "DZ": "Argelia",
  "AS": "Samoa Americana",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguila",
  "AQ": "Antártida",
  "AG": "Antigua y Barbuda",
  "AR": "Argentina",
  "AM": "Armenia",
  "AW": "Aruba",
  "AC": "Isla de la Ascensión",
  "AU": "Australia",
  "AT": "Austria",
  "AZ": "Azerbaiyán",
  "BS": "Bahamas",
  "BH": "Baréin",
  "BD": "Bangladés",
  "BB": "Barbados",
  "BY": "Bielorrusia",
  "BE": "Bélgica",
  "BZ": "Belice",
  "BJ": "Benín",
  "BM": "Bermudas",
  "BT": "Bután",
  "BO": "Bolivia",
  "BA": "Bosnia y Herzegovina",
  "BW": "Botsuana",
  "BR": "Brasil",
  "IO": "Territorio Británico del Océano Índico",
  "BN": "Brunéi",
  "BG": "Bulgaria",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "KH": "Camboya",
  "CM": "Camerún",
  "CA": "Canadá",
  "CV": "Cabo Verde",
  "KY": "Islas Caimán",
  "CF": "República Centroafricana",
  "TD": "Chad",
  "CL": "Chile",
  "CN": "China",
  "CX": "Isla de Navidad",
  "CC": "Islas Cocos",
  "CO": "Colombia",
  "KM": "Comoras",
  "CG": "Congo",
  "CD": "República Democrática del Congo",
  "CK": "Islas Cook",
  "CR": "Costa Rica",
  "CI": "Costa de Marfil",
  "HR": "Croacia",
  "CU": "Cuba",
  "CY": "Chipre",
  "CZ": "República Checa",
  "DK": "Dinamarca",
  "DJ": "Yibuti",
  "DM": "Dominica",
  "DO": "República Dominicana",
  "EC": "Ecuador",
  "EG": "Egipto",
  "SV": "El Salvador",
  "GQ": "Guinea Ecuatorial",
  "ER": "Eritrea",
  "EE": "Estonia",
  "SZ": "Suazilandia",
  "ET": "Etiopía",
  "FK": "Islas Malvinas",
  "FO": "Islas Feroe",
  "FJ": "Fiyi",
  "FI": "Finlandia",
  "FR": "Francia",
  "GF": "Guayana Francesa",
  "PF": "Polinesia Francesa",
  "GA": "Gabón",
  "GM": "Gambia",
  "GE": "Georgia",
  "DE": "Alemania",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GR": "Grecia",
  "GL": "Groenlandia",
  "GD": "Granada",
  "GP": "Guadalupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guinea",
  "GW": "Guinea-Bisáu",
  "GY": "Guyana",
  "HT": "Haití",
  "VA": "Ciudad del Vaticano",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Hungría",
  "IS": "Islandia",
  "IN": "India",
  "ID": "Indonesia",
  "IR": "Irán",
  "IQ": "Irak",
  "IE": "Irlanda",
  "IM": "Isla de Man",
  "IL": "Israel",
  "IT": "Italia",
  "JM": "Jamaica",
  "JP": "Japón",
  "JE": "Jersey",
  "JO": "Jordania",
  "KZ": "Kazajistán",
  "KE": "Kenia",
  "KI": "Kiribati",
  "KP": "Corea del Norte",
  "KR": "Corea del Sur",
  "XK": "Kosovo",
  "KW": "Kuwait",
  "KG": "Kirguistán",
  "LA": "Laos",
  "LV": "Letonia",
  "LB": "Líbano",
  "LS": "Lesoto",
  "LR": "Liberia",
  "LY": "Libia",
  "LI": "Liechtenstein",
  "LT": "Lituania",
  "LU": "Luxemburgo",
  "MO": "Macao",
  "MG": "Madagascar",
  "MW": "Malaui",
  "MY": "Malasia",
  "MV": "Maldivas",
  "ML": "Mali",
  "MT": "Malta",
  "MH": "Islas Marshall",
  "MQ": "Martinica",
  "MR": "Mauritania",
  "MU": "Mauricio",
  "YT": "Mayotte",
  "MX": "México",
  "FM": "Micronesia",
  "MD": "Moldavia",
  "MC": "Mónaco",
  "MN": "Mongolia",
  "ME": "Montenegro",
  "MS": "Montserrat",
  "MA": "Marruecos",
  "MZ": "Mozambique",
  "MM": "Myanmar",
  "NA": "Namibia",
  "NR": "Nauru",
  "NP": "Nepal",
  "NL": "Países Bajos",
  "NC": "Nueva Caledonia",
  "NZ": "Nueva Zelanda",
  "NI": "Nicaragua",
  "NE": "Níger",
  "NG": "Nigeria",
  "NU": "Niue",
  "NF": "Isla Norfolk",
  "MK": "Macedonia del Norte",
  "MP": "Islas Marianas del Norte",
  "NO": "Noruega",
  "OM": "Omán",
  "PK": "Pakistán",
  "PW": "Palaos",
  "PS": "Palestina",
  "PA": "Panamá",
  "PG": "Papúa Nueva Guinea",
  "PY": "Paraguay",
  "PE": "Perú",
  "PH": "Filipinas",
  "PN": "Islas Pitcairn",
  "PL": "Polonia",
  "PT": "Portugal",
  "PR": "Puerto Rico",
  "QA": "Catar",
  "RE": "Reunión",
  "RO": "Rumania",
  "RU": "Rusia",
  "RW": "Ruanda",
  "BL": "San Bartolomé",
  "SH": "Santa Elena",
  "KN": "San Cristóbal y Nieves",
  "LC": "Santa Lucía",
  "MF": "San Martín",
  "PM": "San Pedro y Miquelón",
  "VC": "San Vicente y las Granadinas",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "Santo Tomé y Príncipe",
  "SA": "Arabia Saudita",
  "SN": "Senegal",
  "RS": "Serbia",
  "SC": "Seychelles",
  "SL": "Sierra Leona",
  "SG": "Singapur",
  "SX": "San Martín",
  "SK": "Eslovaquia",
  "SI": "Eslovenia",
  "SB": "Islas Salomón",
  "SO": "Somalia",
  "ZA": "Sudáfrica",
  "GS": "Islas Georgias del Sur y Sandwich del Sur",
  "SS": "Sudán del Sur",
  "ES": "España",
  "LK": "Sri Lanka",
  "SD": "Sudán",
  "SR": "Surinam",
  "SJ": "Svalbard y Jan Mayen",
  "SE": "Suecia",
  "CH": "Suiza",
  "SY": "Siria",
  "TW": "Taiwán",
  "TJ": "Tayikistán",
  "TZ": "Tanzania",
  "TH": "Tailandia",
  "TL": "Timor Oriental",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad y Tobago",
  "TN": "Túnez",
  "TR": "Turquía",
  "TM": "Turkmenistán",
  "TC": "Islas Turcas y Caicos",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ucrania",
  "AE": "Emiratos Árabes Unidos",
  "GB": "Reino Unido",
  "US": "Estados Unidos",
  "UY": "Uruguay",
  "UZ": "Uzbekistán",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Vietnam",
  "VG": "Islas Vírgenes Británicas",
  "VI": "Islas Vírgenes de los Estados Unidos",
  "WF": "Wallis y Futuna",
  "EH": "Sáhara Occidental",
  "YE": "Yemen",
  "ZM": "Zambia",
  "ZW": "Zimbabue",
  "highlight_products": "Productos destacados",
  "highlight_description": "¡Descubre nuestros productos más populares!",
  "highlights": "Destacados",
  "highlight_successfuly_updated": "¡Destacado actualizado con éxito!",
  "highlight_category": "Categoría de productos destacados",
  "highlight_explanation": "¡Los productos marcados con una estrella se destacarán en tu tienda WhatsMenu!",
  "complete_category": "Categoría completa",
  "stripe_test_key_not_allowed": "No se permiten claves de prueba. Por favor, use una clave de producción (sk_live_).",
  "fees_settings": "Configuraciones de tarifas",
  "dashboard_auto_assign": "Cupón automático",
  "congrats_auto_assign": "🎉 ¡FELICIDADES! Has ganado",
  "auto_assign_discount": "de descuento!",
  "store_auto_assign_1": "Agrega",
  "store_auto_assign_2": "más para ganar",
  "price_from": "Antes:",
  "price_to": "Ahora:",
  "progressive_discount": "Descuento progresivo",
  "progressive_discounts": "Descuentos progresivos",
  "progressive_discount_manager": "Gestión de descuentos progresivos",
  "discounts": "Descuentos",
  "discount_status": "Estado del descuento",
  "delete_discount": "Eliminar descuento",
  "delete_discount_confirm": "¿Está seguro de que desea eliminar el descuento?",
  "discount_not_created": "Descuento no creado",
  "discount_not_created_desc": "No fue posible crear el descuento",
  "discount_name": "Nombre del descuento",
  "discount_already_exists": "El descuento ya existe",
  "discount_invalid_chars": "No se permiten caracteres especiales",
  "discount_allowed_chars_hint": "Solo letras, números, guión (-) y guión bajo (_)",
  "discount_code_valid": "Nombre disponible",
  "applied_discount": "Descuento aplicado",
  "invalid_coupon": "¡El cupón no es válido!",
  "select_your_discount": "Selecciona tu descuento",
  "cashback_why_better": "Por qué el cashback supera las promociones tradicionales y los anuncios en portales",
  "cashback_money_attractive": "El dinero es más atractivo que los puntos",
  "cashback_defined_validity": "Vigencia definida",
  "cashback_controlled_cost": "Costo controlado",
  "cashback_total_automation": "Automatización total",
  "cashback_rewards_now": "El cashback recompensa el ahora. El cliente regresa porque siente que ya ganó y no puede perder el dinero.",
  "cashback_growth_impact": "Crecimiento e Impacto Real en Ticket Promedio y Frecuencia",
  "cashback_how_to_activate": "CÓMO ACTIVAR ESTA FUNCIÓN:",
  "cashback_set_percentage": "Establece el porcentaje",
  "cashback_choose_validity": "Elige la vigencia",
  "cashback_activate_save": "Activa y guarda",
  "check_for_updates": "Buscar actualizaciones",
  "update_alert": "Alerta de actualización",
  "update_unavailable": "No hay actualizaciones disponibles.",
  "configure_extra_fees": "Configura a continuación las tarifas adicionales de servicios o recargos. Estas tarifas se cobrarán a tu cliente al final de cada pedido. Ej.: cubierto artístico, valet, servicio de camarero, cargo por servicio o impuesto.",
  "fees_already_exists": "Ya existe una tarifa con este nombre.",
  "fees_name_cannot_be_empty": "El nombre de la tarifa no puede estar vacío.",
  "fees_name_too_long": "El nombre de la tarifa no puede tener más de 20 caracteres.",
  "fees_min_value": "Ingrese un valor mayor que {{value}}",
  "fees_created": "Tarifa {{code}} creada con éxito",
  "fees_updated": "{{code}} actualizada con éxito.",
  "fees_deleted": "Tarifa {{code}} eliminada con éxito",
  "highlight_limit": "Puedes tener un máximo de 10 productos destacados.",
  "consider_current_value": "Si algún valor ha sido modificado, se considerará el valor actual",
  "unavailable_products": "Productos no disponibles",
  "unavailable_products_desc": "Los siguientes productos y/o sus complementos no están disponibles",
  "continue_anyway": "Continuar de todos modos",
  "total_clients": "Total de Clientes",
  "inactive_30d": "Inactivos por +30 días",
  "new_clients": "Nuevos Clientes",
  "last_order": "Último Pedido",
  "favorite_product": "Producto Favorito",
  "segment": "Segmento",
  "inactive_client": "Inactivo",
  "new_client": "Nuevo",
  "recurring_client": "Recurrente",
  "loyal_client": "Fiel",
  "days_ago": "hace {{count}}d",
  "days_without_order": "{{count}}d sin pedir",
  "segments": "Segmentos",
  "clear_filters": "Limpiar filtros",
  "inactive_days_label": "Sin pedido hace (días)",
  "min_ticket_label": "Ticket mín.",
  "max_ticket_label": "Ticket máx.",
  "client_analysis": "Análisis del Cliente",
  "cancellation_rate": "Tasa de Cancelación",
  "mom_change": "Variación M/M",
  "biggest_order": "Mayor Pedido",
  "smallest_order": "Menor Pedido",
  "most_ordered_products": "Productos Más Pedidos",
  "no_data": "Sin datos",
  "monthly_frequency": "Frecuencia Mensual",
  "trend_up": "↑ creciente",
  "trend_down": "↓ decreciente",
  "trend_stable": "→ estable",
  "avg_ticket_by_month": "Ticket Promedio por Mes",
  "preferred_order_days": "Días Preferidos para Pedir",
  "repurchase_interval": "Intervalo de Recompra",
  "average": "Promedio",
  "median": "Mediana",
  "samples": "Muestras",
  "requires_at_least_2_orders": "Se necesitan al menos 2 pedidos",
  "export_csv": "Exportar CSV",
  "no_client_found_by_name": "No se encontró ningún cliente con ese nombre",
  "based_on_last_orders": "Basado en los últimos {{count}} de {{total}} pedidos",
  "segment_inactive_15d": "Inactivos 15d",
  "segment_inactive_30d": "Inactivos 30d",
  "segment_inactive_60d": "Inactivos 60d",
  "segment_new_1_order": "Nuevos (1 pedido)",
  "segment_high_ticket": "Ticket alto",
  "back_to_list_detail": "← Volver a la lista",
  "highlight": "Destacado",
  "trend": "Tendencia",
  "weighted_average": "Promedio Ponderado",
  "intervals": "Intervalos",
  "low_confidence_sample": "⚠ muestra baja",
  "intervals_in_range": "intervalo(s) en este rango",
  "ticket_label": "Ticket",
  "total_label": "Total",
  "no_orders_this_month": "Sin pedidos este mes",
  "block_date": "Fecha de Bloqueo",
  "payment_date": "Fecha de Pago",
  "cmv_report_title": "Reporte de CMV",
  "cmv_health_score": "Puntuación de Salud",
  "cmv_alert_critical": "productos con CMV crítico!",
  "cmv_alert_critical_desc": "Los productos con CMV superior al 35% comprometen la rentabilidad.",
  "cmv_alert_potential_savings": "Ahorro potencial por unidad:",
  "cmv_alert_priority_products": "Productos prioritarios para revisión:",
  "cmv_coverage_title": "Cobertura de costos:",
  "cmv_coverage_desc": "productos sin costo registrado. Registra los costos para un análisis completo y decisiones precisas.",
  "cmv_success_title": "Excelente! Tu precio está saludable",
  "cmv_success_desc": "No hay productos con CMV crítico. Sigue monitoreando regularmente.",
  "cmv_avg": "CMV Promedio",
  "cmv_very_high": "CMV Muy Alto",
  "cmv_ideal": "CMV Ideal",
  "cmv_very_low": "Muy Bajo",
  "cmv_no_cost": "Sin costo",
  "cmv_urgent_action": "Acción urgente",
  "cmv_perfect": "Perfecto",
  "cmv_register_costs": "Registrar costos",
  "cmv_see_products": "Ver productos",
  "cmv_search_product": "Buscar Producto",
  "cmv_search_placeholder": "Nombre o categoría...",
  "cmv_category": "Categoría",
  "cmv_all_categories": "Todas",
  "cmv_type": "Tipo",
  "cmv_delivery": "Entrega",
  "cmv_table": "Mesa",
  "cmv_status": "Estado del CMV",
  "cmv_all_status": "Todos",
  "cmv_export_excel": "Exportar Excel",
  "cmv_showing": "Mostrando",
  "cmv_of": "de",
  "cmv_products": "productos",
  "cmv_with_costs": "con costos registrados",
  "cmv_how_to_interpret": "Cómo interpretar el CMV:",
  "cmv_very_high_desc": "Costo muy alto. Negocia con proveedores o ajusta el precio.",
  "cmv_ideal_desc": "Rango saludable de rentabilidad.",
  "cmv_very_low_desc": "Margen alto. Considera estrategias promocionales.",
  "cmv_updated_at": "Actualizado en:",
  "cmv_loading": "Cargando análisis de CMV...",
  "cmv_product": "Producto",
  "cmv_sale_price": "Precio de venta",
  "cmv_cost": "Costo",
  "cmv_no_products_found": "No se encontraron productos con los filtros aplicados",
  "cmv_no_products_yet": "Aún no hay productos registrados",
  "cmv_clear_filters": "Limpiar filtros",
  "cmv_disclaimer_1": "El CMV (Costo de Mercancía Vendida) representa solo costos directos de adquisición/producción.",
  "cmv_disclaimer_2": "Impuestos, comisiones, envío, empaques y costos fijos (alquiler, energía) no están incluidos en este cálculo.",
  "cmv_insight_title": "Análisis de CMV",
  "cmv_insight_delivery": "Entrega",
  "cmv_insight_table": "Mesa",
  "cmv_insight_margin": "Margen",
  "cmv_insight_profit_per_sale": "Ganancia por venta",
  "cmv_insight_status_critical": "CMV Crítico!",
  "cmv_insight_status_high": "CMV Alto",
  "cmv_insight_status_ideal": "CMV Ideal",
  "cmv_insight_status_low": "CMV Muy Bajo",
  "cmv_insight_suggestion_critical": "Negocia con proveedores o aumenta el precio",
  "cmv_insight_suggestion_high": "Considera ajustar el costo o el precio de venta",
  "cmv_insight_suggestion_ideal": "Margen saludable! Sigue monitoreando",
  "cmv_insight_suggestion_low": "Excelente margen! Considera promociones",
  "cmv_insight_enter_cost": "Ingresa el costo para ver el análisis",
  "cmv_insight_enter_price": "Ingresa el precio para ver el análisis",
  "eat_on_site": "Comer en el local",
    "eat_on_local_subtitle": "Consumo en el local, sin costo de entrega ni empaque",
  "Can_the_customer_eat_here": "El cliente puede pedir para comer en el local",
  "cart_type": "Tipo de pedido",
  "eat_here": "Voy a comer en el local",
  "flavor_badge_configure": "Configurar Etiqueta",
"flavor_badge_text_label": "Texto de la Etiqueta",
"flavor_badge_text_placeholder": "Ej: Nuevo, Más pedido",
"flavor_badge_color_label": "Color de la Etiqueta",
"flavor_badge_color_hint": "Elige el color de fondo",
"flavor_badge_name_fallback": "Nombre del Sabor",
"flavor_badge_description_fallback": "Tu descripción aquí...",
"flavor_badge_preview_alt": "Vista previa",
"flavor_badge_remove": "Eliminar etiqueta",
"flavor_badge_add": "+ etiqueta",
  "table_quick_search": "Búsqueda rápida",
"table_search_placeholder": "Mesa, número o mesero",
"table_status_filter_label": "Estado de la mesa",
"table_filter_all": "Todas",
"table_filter_open": "Abiertas",
"table_filter_closed": "Cerradas",
"table_payment_filter_label": "Pago",
"filter_all": "Todos",
"payment_status_paid": "Pagado",
"payment_status_partial": "Parcial",
"payment_status_pending": "Pendiente",
"table_waiter_filter_label": "Mesero",
"table_open_badge": "Abierta",
"table_closed_badge": "Cerrada",
"table_orders_pending_tooltip": "{{count}} pedido(s) en espera",
"table_order_singular": "pedido",
"table_order_plural": "pedidos",
"table_orders_cancelled": "cancelado(s)",
"table_open_duration": "abierta hace {{hours}}h{{minutes}}min",
"table_closed_duration": "estuvo abierta por {{hours}}h{{minutes}}min",
"table_no_time": "sin horario",
"table_waiter_name_label": "Mesero:",
"payment_cleared": "Pago completado",
"payment_partial_label": "Pago parcial",
"payment_pending_label": "Pago pendiente",
"table_total_value_label": "Total:",
"nfe_emitted_tooltip": "NFC-e fue emitida",
"nfe_emit_tooltip": "Emitir NFC-e",
"nfe_no_eligible_orders": "Sin pedidos elegibles para emisión",
"nfe_close_table_first": "Cierre la mesa para emitir NFC-e",
"nfe_emitted_alt": "NFC-e emitida de la mesa",
"nfe_emit_table_alt": "Emitir NFC-e de la Mesa",
"nfe_blocked_alt": "NFC-e bloqueada",
"table_paid_label": "Pagado:",
"table_due_label": "Falta:",
"table_fixed_fee_label": "Cargo fijo:",
"table_percentage_fee_label": "Cargo porcentual:",
"table_print_col": "Impr",
"table_order_code_col": "Cód. Pedido",
"table_name_col": "Nombre",
"table_total_col": "Total",
"table_time_col": "Hora",
"table_status_col": "Estado",
"table_served_status": "Servido",
"table_fees_footer": "Cargos: +{{fixed}} / +{{percentage}}%",
"table_total_footer_label": "Total de la mesa:",
"table_no_results": "Ninguna mesa encontrada para los filtros aplicados.",
"table_name_fallback": "Mesa #{{id}}",
"table_payment_not_informed": "No informado",
"delivery_person_signed_successfully": "Repartidor firmado con éxito",
"icon_category": "Icono de la Categoría",
"icon_category_optional": "Icono de la categoría (opcional)",
"edit_order": "editar pedido",
"editing_ongoing": "Edición en curso",
"cancelled_parentheses": "(CANCELADO)",
"news": "Novedades",
"cashback_message": "Generaste R$ {{cartTotalCashback}} en ventas, impulsadas por R$ {{cartTotalCashbackValue}} en cashback.",
"group_fees": "Agrupar tarifas",
"technical_support": "Soporte técnico",
"everyday": "De lunes a domingo"
}
